<template>
  <div v-if="isLoading">
    <div class="text-center text-danger screen-center">
      <div class="align-middle spinner-bubble spinner-bubble-danger mr-5"></div>
      <strong>Cargando...</strong>
    </div>
  </div>
  <div v-else>
    <div v-if="activeHC">
      <historialClinicaInternacion
        :dataPaciente="dataPaciente"
        :edit="true"
        :activeHC="activeHC"
        :historialClinico="historialClinico[0]"
        :numero_internacion="numero_internacion"
        :fecha_ingreso="fecha_ingreso"
        :hora_ingreso="hora_ingreso"
        @historial-clinico-enviado="manejarHistorialClinico"/>
    </div>
    <div v-else>
    <div class="row">
      <div class="col-sm-4">
        <div class="breadcrumb">
          <h1>Modificar Internacion <span class="h4 pl-2"> N°: {{numero}}</span></h1>
        </div>
      </div>
      <!-- aqui va la transicion con la barra informativa superior -->
      <transition name="fade">
        <div class="col-sm-8 navbar-reubicado">
          <div class="row">
            <div class="col-sm-12 py-2 bg-sky-light text-white">
              <div class="row" style="white-space: nowrap;">
                <div class="col-2">
                   <b>Edad:</b> {{dataPaciente.edad}} años
                </div>
                <div class="col-2">
                  <b>H.C:</b> {{dataPaciente.numero}}
                </div>
                <div class="col-4" v-show="dataPaciente.contacto">
                  <p style="font-size: 12px">Contacto 1: {{ dataPaciente.contacto }} </p>
                </div>
                <div class="col-4" v-if="dataPaciente.familiar">
                  <p style="font-size: 12px" >
                    Familiar 1:
                    {{ dataPaciente.familiar }} </p>
                </div>
                <div
                  v-if="dataPaciente.tipo_seguro==='Conjunto'"
                  class="col-sm-6 px-1"
                >
                  <b>Seguro:</b> {{dataPaciente.cobertura}}
                  <span v-if="dataPaciente.tipo_familiar">
                    ({{dataPaciente.tipo_familiar}})
                  </span>
                </div>
                <div
                  v-if="dataPaciente.numero_poliza || dataPaciente.cod_asegurado"
                  class="col-sm-2 px-1"
                >
                  <template v-if="dataPaciente.numero_poliza">
                    <b>N° Poliza: </b>{{dataPaciente.numero_poliza}}
                  </template>
                  <template v-else>
                    <b>N° Cod.:</b>{{dataPaciente.cod_asegurado}}
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
    <div class="row mb-2">
      <div class="col-sm-12">
        <div class="card text-left">
          <div class="card-header">
            <div class="row">
              <div class="col-sm-5">
                <button
                  type="submit"
                  class="btn bg-custom-green mr-2 rounded"
                  :disabled="buttonDisable"
                  @click="update"
                >
                  <span
                    v-if="buttonDisable"
                    class="spinner-border spinner-border-sm mr-1"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  Guardar
                </button>
                <router-link :to="{ name: 'internacion-index' }">
                  <button
                    class="btn btn-white border border-light rounded">
                    Regresar
                  </button>
                </router-link>
              </div>
              <div v-if="has_tratamiento_farmacia_mecicamento"  class="col-sm-7 text-right">
                <div class="row">
                  <div class="col">
                    <label class="col-form-label">Los medicamentos se proporcionarán de Farmacia:</label>
                    <button
                    class="ml-2 px-2 btn "
                    :class="medicationsProvidesByPharmacy === false ? 'btn-danger':'btn-secondary'"
                    @click="rejectAutorizacion"
                  >
                    Rechazado
                  </button>
                  <button
                    class="ml-2 px-2 btn"
                    :class="medicationsProvidesByPharmacy === true ? 'btn-success':'btn-dark'"
                    @click="openModalAutorizacionInternacion"
                  >
                    Confirmado
                  </button>
                    <label  v-if="medicationsProvidesByPharmacy === true" class="col-form-label ml-2 px-2 ">Imprimir</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="card-body">
            <div class="row mb-2">
              <div class="col-sm-6">
                <TheModalPreCierre
                  ref="theModalPreCierre"
                  :servicios_internos="serviciosFiltered"
                  :cxp="cuentas_x_pagar"
                  :salidProducto="salidaProductos.detalles"
                  :paciente="dataPaciente"
                  :preCierreData="preCierreData"
                  :editMode="true"
                  :moneda="moneda"
                  @agregarPrecierre="agregarPrecierre"
                  @update:estado_precierre="preCierre=$event"
                  v-on:limpiarPreCierre="limpiarPreCierre"
                  @agregarCierre="agregarCierre"
                  :serviciosComplementarios="servicioComplementario"
                  :totalImporteSalaCama="totalImporteSalaCama"
                />
                <ModalCierre
                  :preCierre="preCierre"
                  :preCierreData="preCierreData"
                  :cierreData="cierre"
                  @agregarCierre="agregarCierre"
                />
                <button v-if="has_active_hc"
                      class="ml-2 px-2"
                      :class="!verificarHistorialClinico(historialClinico) ? 'btn btn-success' : 'btn btn-secondary'"
                      @click="goToHistorialClinico">
                H.C. Internacion
              </button>
              <button
              class="ml-2 px-2"
              @click="openModalSignosVitales"
              :class="signosVitales.length > 0 ? 'btn btn-success' : 'btn btn-secondary'"
              >
              Signos Vitales
            </button>
            <button
                class="ml-2 px-2"
                :class="hasValidAntecedentes() ? 'btn btn-success' : 'btn btn-secondary'"
                @click="openModalAntecedentes"
              >
                Antecendetes
            </button>
              </div>
                <div class="col-sm-6">
                  <div class="d-flex justify-content-end align-items-center">
                    <button
                      v-if="isBloqueoDescuentoInternacion && preCierre && (isActiveLaboratorio
                        || isActiveEcografia
                        || isActiveRayosX
                        || isActiveTomografia
                        || isActiveArcoC)"
                      class="ml-2 px-2"
                      :class="(descuento_monto > 0 || descuento_gral === 1 || tieneDiasAnulados)
                        ? 'btn btn-success' : 'btn btn-secondary'"
                      @click="openModalDescuentos"
                    >
                      Descuentos
                    </button>
                    <div
                      v-if="seguro.model && isDisableSeguro && tipoSeguroSeleccionado > 0"
                      class="ml-2"
                    >
                      <label class="mb-0 mr-1">Limite Seguro:</label>
                      <button class="px-2 btn btn-danger">
                        {{ total }} /
                        <span style="color: black;" v-if="seguro.model">{{ tipoSeguroSeleccionado }}</span>
                        <span style="color: black;" v-else>0</span>
                      </button>
                    </div>
                  </div>
                </div>
            </div>
            <div class="row mb-3">
              <div class="col-sm-6">
                <div class="row">
                  <div class="col-sm-12">
                    <b-card class="mb-3">
                      <div class="row mb-3">
                        <div class="col-sm-2 text-right pr-0">
                          <label class="col-form-label">
                            Fecha:
                          </label>
                        </div>
                        <div class="col-sm-4 px-0">
                          <date-picker
                            :disabled="true"
                            class="col-sm-10"
                            v-model="fecha"
                            lang="es"
                            format="DD/MM/YYYY"
                            type="date"
                            value-type="date"
                          ></date-picker>
                        </div>
                        <div class="col-sm-2 text-right pr-0">
                          <label class="col-form-label">
                            Fecha Cierre:
                          </label>
                        </div>
                        <div class="col-sm-4 px-0">
                          <date-picker
                            class="col-sm-10"
                            v-model="fechaCierre"
                            lang="es"
                            format="DD/MM/YYYY"
                            type="date"
                            value-type="date"
                          ></date-picker>
                        </div>
                      </div>
                      <div class="row mb-3">
                        <div class="col-sm-2 text-right pr-0">
                          <label class="col-form-label">
                            Paciente:
                          </label>
                        </div>
                        <div class="col-sm-8">
                          <ComboPaciente
                          id="comboPaciente"
                          :paciente="pacienteSelected"
                          :edit="edit"
                          v-on:addPaciente="AddPaciente"
                          :havePreCierre="preCierre"
                        />
                        </div>
                        <!-- <div class="col-sm-2 pl-0 pr-2" v-if="pacienteSelected">
                          <input
                            id="hc"
                            type="text"
                            class="form-control"
                            :value="'H.C: '+dataPaciente.numero"
                            disabled
                          >
                        </div> -->
                        <div class="col-sm-1 px-0">
                          <button
                            class="btn btn-success col-sm-12 px-0"
                            @click="openModalPaciente"
                          >
                            <i class="i-Business-ManWoman h5"></i>
                          </button>
                          <ModalPacienteNuevo />
                        </div>
                      </div>
                    </b-card>
                  </div>
                </div>

                <div class="row mb-2">
                  <div class="col-sm-12">
                    <b-card class="border border-light small-card">
                      <b class="small-text">Diagnóstico: </b><span class="text-danger">(Obligatorio)</span>
                      <div class="row mt-1 mb-2">
                        <ComboDiagnostic
                        :id="'comboDiagnostic'"
                        :diagnostico-inicial="diagnosticoSeleccionado"
                        @addDiagnostico="guardarDiagnosticoSeleccionado"
                        class="small-combo-diagnostic"
                      />
                      </div>
                      <div class="row">
                        <div class="col-sm-12">
                          <input
                            v-model="diagnostico"
                            type="text"
                            class="form-control small-input"
                          >
                        </div>
                      </div>
                    </b-card>
                  </div>
                </div>

                <div class="row">
                  <div class="col-sm-12">
                    <b-card class="border border-light">
                      <b class="text-light">Solicitar Cirugia:</b>
                      <div class="row mx-0 pt-1">
                        <QuirofanoItem v-for="(item, index) in cirugias" :key="index"
                          :indexCirugia="index+1"
                          @click.native="openModalCirugia(false)"
                        />
                        <QuirofanoItem
                          :modeAddCirugia="true"
                          @click.native="openModalCirugia(true)"
                        />
                      </div>
                      <TheModalCirugia
                        v-model="modeAddItem"
                        @addNewItem="addItemCirugia($event)"
                        @onChangeData="saveData($event)"
                      />
                    </b-card>
                  </div>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="row">
                  <div class="col-sm-12">
                    <b-card class="mb-4">
                      <div class="row mb-3">
                        <div class="col-sm-3 px-0 ml-2 text-right">
                          <label class="col-form-label text-skyblue font-weight-bold">
                            {{labelTratamiento}}:
                          </label>
                        </div>
                        <div class="col-sm-8">
                          <multiselect2
                            v-model="categoriaTratamiento.model"
                            selectLabel=""
                            selectedLabel=""
                            deselect-label="X"
                            track-by="nombre"
                            label="nombre"
                            multiple
                            placeholder="Seleccione un item"
                            :options="categoriaTratamiento.listaCategorias"
                            :allow-empty="false"
                            :searchable="true">
                          </multiselect2>
                        </div>
                      </div>
                      <div class="row mb-3">
                        <div class="col-sm-3 px-0 ml-2 text-right">
                          <label class="col-form-label text-skyblue font-weight-bold">
                            Medico Principal:
                          </label>
                        </div>
                        <div class="col-sm-8">
                          <multiselect2
                            v-model="medico.model"
                            selectLabel=""
                            selectedLabel=""
                            deselect-label="X"
                            track-by="nombre"
                            label="nombre"
                            placeholder="Seleccione un medico"
                            :options="medico.listaMedicos"
                            multiple
                            :searchable="true">
                          </multiselect2>
                        </div>
                      </div>
                      <div class="row mb-3" v-if="isDisableSeguro">
                        <div class="col-sm-2 text-right pr-0">
                          <label class="col-form-label text-light">
                            Seguro:
                          </label>
                        </div>
                        <div class="col-sm-6">
                          <multiselect2
                            v-model="seguro.model"
                            selectLabel=""
                            selectedLabel=""
                            deselect-label="X"
                            track-by="nombre_comercial"
                            label="nombre_comercial"
                            placeholder="Seleccione un seguro"
                            :options="seguro.listaSeguros"
                            :searchable="true"
                            disabled
                          >
                          </multiselect2>
                        </div>
                        <div class="col-sm-4">
                          <hojaAdmision
                          :isEdit="true"
                          :has_Admision="has_Admision"
                          :paciente_id="dataPaciente.id"
                          :tratamiento_id="id"
                          :familiarPaciente="responsable_paciente"
                          @familiar-seleccionado="manejarFamiliarSeleccionado"
                          />
                        </div>
                      </div>
                      <div class="row mb-2">
                        <div class="col-sm-2 pr-1">
                          <button
                            class="btn col-sm-12"
                            :class="colorBtnPieza"
                            @click="openModalPieza"
                            :disabled="true"
                          >
                            Pieza
                          </button>
                          <ModalPieza :editMode="true"/>
                        </div>
                        <div class="col-sm-3 pr-1">
                          <input
                            :value="getCamaItemChecked"
                            type="text"
                            class="form-control text-center px-1"
                            disabled
                          >
                        </div>
                        <div class="col-sm-4 pl-1">
                          <input
                            :value="getPisoSalaItemChecked"
                            type="text"
                            class="form-control text-center px-1"
                            disabled
                          >
                        </div>
                        <div class="col-sm-2" v-if="getPisoSalaItemChecked"
                          style="margin: auto;">
                          <span>{{ diasTratamiento }}</span> Dias
                        </div>
                      </div>
                      <div class="row mb-2 text-center"
                        v-if="preCierreData.first_precierre_tratamiento_edit && datoPieza">
                        <span style="color: red; margin:auto;">
                          Ya no hace recuento
                          ( Fecha: {{ fechaFirstPrecierre }}
                            H: {{ horaFirstPrecierre }}
                            - {{ preCierreData.usuario }}
                          )
                        </span>
                      </div>
                    </b-card>
                  </div>
                </div>

                <div class="row">
                  <div class="col-sm-12">
                    <b-card class="border border-light">
                      <b class="text-light">Inter Consulta:</b>
                      <div class="row mx-0 pt-1">
                        <div
                              v-for="(item, index) in interConsultas" :key="index"
                              @click="setInterConsulta(item, index)"
                              class="cursor-pointer col-sm-2 px-0 mr-3 my-2 rounded white"
                              :style="{
                                background: item.respuesta && item.respuesta.respuesta_id > 0 ? '#4caf50' : '#ffc107',
                                color: item.respuesta && item.respuesta.respuesta_id > 0 ? '#fff' : '#858189'
                              }"
                              style="background: #eee; height: 90px; display: flex; align-items: center; justify-content: center; user-select: none;"
                            >
                              <b>
                                Inter {{ index + 1 }}
                              </b>
                            </div>
                          <div
                          @click="openModalInterConsulta"
                          class="cursor-pointer col-sm-2 px-0 mr-3 my-2 border rounded"
                          style="height: 90px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            user-select: none;"
                        >
                          <span
                            class="h1 pt-2"
                            style="color:#858189;"
                          >+</span>
                        </div>
                      </div>
                      <TheModalInterConsulta :idInterconsulta="Number(id)"/>
                    </b-card>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-9 pl-4" style="display: inline;">
                <b><font size=3>Servicios Complementarios</font></b>
              </div>
              <div class="col-sm-3">
                <div class="form-group row">
                  <div class="col-sm-12">
                    <multiselect2
                      v-model="almacen.model"
                      selectLabel=""
                      selectedLabel=""
                      deselect-label="X"
                      track-by="almacen"
                      label="almacen"
                      placeholder="Seleccione Almacen"
                      :options="almacen.listaAlmacenes"
                      :disabled="isDisabledAlmacen"
                      :allow-empty="false"
                      :searchable="true">
                    </multiselect2>
                  </div>
                </div>
              </div>
            </div>
            <!-- servicios complementarios buttons -->
            <div class="row mb-2">
              <div class="col-sm-12" style="background: #f4b375;">
                <div class="form-group row">
                  <div class="col-sm-12 pt-2">
                    <the-modal-consumo-productos
                      :isActiveProductos="isActiveFarmacia"
                      :almacen="almacen.model"
                      :moneda="moneda.model"
                      :fecha="fecha"
                      :sugerencia_glosas="sugerencias_glosas_sp"
                      :detalles="productosEdit"
                      :havePreCierre="preCierre"
                      :activateButton="nombreButtonActivo == 'productos' ? true : false"
                      v-on:addProducto="addProducto"
                      v-on:activateTheButton="activateTheButton"
                      :nameButton="getNameFarmacia"
                      ref="theModalConsumoProducto"
                      :hasActiveEvolucionMedica="hasActiveEvolucionMedica"
                      :has_active_receta="has_active_receta"
                      :has_active_insumo="has_active_insumo"
                      :has_active_venta="has_active_venta"
                      :tipoViaAdministracions="tipoViaAdministracions"
                      :aseguradora_id="seguro.model ? seguro.model.id : null"
                      />
                    <button
                      v-if="isActiveLaboratorio"
                      class="btn btn-sm text-white mr-2"
                      :id="'popover-target-2'"
                      type="button"
                      :class="getClassButtonLaboratorio"
                      :disabled="preCierre"
                      @click="openModalServicios(getNameLaboratorio, categoriaLaboratorio)"
                    >
                      {{getNameLaboratorio}}
                    </button>
                    <button
                      v-if="isActiveEcografia"
                      class="btn btn-sm text-white mr-2"
                      :id="'popover-target-3'"
                      type="button"
                      :class="getClassButtonEcografia"
                      :disabled="preCierre"
                      @click="openModalServicios(getNameEcografia, categoriaEcografia)"
                    >
                      {{getNameEcografia}}
                    </button>
                    <button
                      v-if="isActiveRayosX"
                      class="btn btn-sm text-white mr-2"
                      :id="'popover-target-4'"
                      type="button"
                      :class="getClassButtonRayosX"
                      :disabled="preCierre"
                      @click="openModalServicios(getNameRayosX, categoriaRayosX)"
                    >
                      {{getNameRayosX}}
                    </button>
                    <button
                      v-if="isActiveTomografia"
                      class="btn btn-sm text-white mr-2"
                      :id="'popover-target-5'"
                      type="button"
                      :class="getClassButtonTomografia"
                      :disabled="preCierre"
                      @click="openModalServicios(getNameTomografia, categoriaTomografia)"
                    >
                      {{getNameTomografia}}
                    </button>
                    <button
                      v-if="isActiveMamografia"
                      class="btn btn-sm text-white mr-2"
                      :id="'popover-target-5'"
                      type="button"
                      :class="getClassButtonMamografia"
                      :disabled="preCierre"
                      @click="openModalServicios(getNameMamografia, categoriaMamografia)"
                    >
                      {{getNameMamografia}}
                    </button>
                    <button
                      v-if="isActiveArcoC"
                      class="btn btn-sm text-white mr-2"
                      :class="getClassButtonArcoC"
                      :disabled="preCierre"
                      @click="openModalServicios(getNameArcoEnC, categoriaArcoC)"
                    >
                      {{getNameArcoEnC}}
                    </button>
                    <button
                      v-if="isActiveFisioterapia"
                      class="btn btn-sm text-white mr-2"
                      :class="getClassButtonFisioterapia"
                      :disabled="preCierre"
                      @click="openModalFisioterapia(getNameFisioterapia, categoriaFisioterapia)"
                    >
                      {{getNameFisioterapia}}
                    </button>
                    <button
                      v-if="isActiveTratamiento"
                      class="btn btn-sm text-white mr-2"
                      :class="getClassButtonTratamiento"
                      :disabled="preCierre"
                      @click="openModalFisioterapia(getNameTratamiento, categoriaTratam)"
                    >
                      {{getNameTratamiento}}
                    </button>
                    <button
                      v-if="hasActiveEvolucionMedica"
                      type="button"
                      class="btn-sm text-white mr-2"
                      :class="nombreButtonActivo == 'evolucion_medica' ?
                        'btn btn-success': 'btn btn-secondary'"
                      @click="onClickButtonEvolucionMedica"
                    >
                      Evolución Médica
                    </button>
                    <the-modal-servicio-externo
                      v-if="hasActiveServicioExt"
                      :data="dataModalCXP"
                      v-on:addCuentaPorPagar="editAddCuentaPorPagar"
                      :havePreCierre="preCierre"
                      :activateButton="nombreButtonActivo == 'servicio_externo' ? true : false"
                      v-on:activateTheButton="activateTheButton"
                    />
                    <TheModalServicioInterno
                      v-if="hasActiveServicioInt"
                      ref="servicioInterno"
                      @addServiciosInternos="addServiciosInternos"
                      :empresa_moneda="empresa_moneda"
                      :sugerencia_glosas="sugerencias_glosas"
                      :medic="medico.listaMedicos"
                      :servicios_internos="serviciosAllInternos"
                      :havePreCierre="preCierre"
                      :activateButton="nombreButtonActivo == 'servicio_interno' ? true : false"
                      @activateTheButton="activateTheButton"
                    />
                    <TheModalEvolucionMedica
                      @addEvolucionMedica="addEvolucionMedica"/>
                  </div>
                </div>
              </div>
            </div>

            <!-- tabla consumo productos -->
            <div class="row mb-2" v-show="nombreButtonActivo=='productos'">
              <div class="col-sm-12 px-0">
                <table class="table table-striped mb-0 table-hover">
                  <thead>
                    <tr>
                      <th width="2%"  class="th-custom-color text-center">N°</th>
                      <th width="10%" class="th-custom-color text-center">Cantidad</th>
                      <th width="40%" class="th-custom-color text-center">Nombre</th>
                      <th width="10%" class="th-custom-color text-center">Importe</th>
                      <th width="20%" class="th-custom-color text-center">Concentrado</th>
                      <th width="10%" class="th-custom-color text-center">Via</th>
                      <th width="15%" class="th-custom-color text-center">Indicacion</th>
                      <th width="3%" class="th-custom-color text-center"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="filterListaTemporalConsumoProducto.length === 0">
                      <td colspan="7" class="text-center">
                        No hay consumo productos registrados
                      </td>
                    </tr>
                    <tr v-for="(item, index) in filterListaTemporalConsumoProducto" :key="index">
                      <td class="text-center">{{item.numero}}
                        <div v-if="item.tipo_consumo !== 3" class="custom-small-text">{{formattedDate(item.fecha)}}</div>
                        <div v-else class="custom-small-text">{{formattedDate(item.fecha_hora)}}</div>
                      </td>
                      <td class="text-center">
                        <button
                        :class="{
                          'btn btnOrange': item.tipo_consumo === 1,
                          'btn btnTurquesa': item.tipo_consumo === 2,
                          'btn btnBlue': item.tipo_consumo === 3
                        }"
                        >
                          {{item.cantidad}}
                        </button>
                      </td>
                      <td class="text-center">{{item.producto_nombre}}</td>
                      <div v-if="item.tipo_consumo !== 3">
                        <td class="text-center">{{ parseFloat(item.importe).toFixed(2) }}</td>
                      </div>
                      <div v-else>
                        <td class="text-center"></td>
                      </div>
                      <td class="text-center"></td>
                      <td class="text-center">{{item.via}}</td>
                      <td class="text-center">{{item.indicacion}}</td>
                      <td class="text-center">
                        <i
                          v-if="!preCierre"
                          class="nav-icon i-Close-Window text-danger font-weight-bold"
                          style="cursor: pointer"
                          @click="eliminarProducto(item)"
                        ></i>
                        <i v-else
                          class="nav-icon i-Close-Window font-weight-bold"
                          style="cursor: pointer"
                          :title="messagePreCierre"
                        ></i>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div v-if="filterListaTemporalConsumoProducto.length > 0">
                  <div class="row  text-right">
                    <div class="col-sm-1 ml-auto th-custom-color">
                      <h4><strong>Total:</strong></h4>
                    </div>
                    <div class="col-sm-1 mr-3 th-custom-color">
                      <div class="div-input bg-main">{{this.totalImporte.toFixed(2)}}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- tabla servicio internos -->
            <div class="row mb-2" v-show="nombreButtonActivo=='servicio_interno'">
              <div class="col-sm-12 rounded th-custom-color text-black py-2">
                <div class="row">
                  <div class="col-sm-1 font-weight-bold"> &nbsp;&nbsp;</div>
                  <div class="col-sm-3 font-weight-bold">Fecha</div>
                  <div class="col-sm-6 font-weight-bold">Servicios</div>
                  <div class="col-sm-2 font-weight-bold text-center">Hora</div>
                </div>
              </div>
              <div class="col-sm-12"
                :class="serviciosFiltered.length > 2? 'tabla-scroll-vertical': ''">
                <template v-if="serviciosFiltered.length > 0">
                  <div
                    class="row mb-2 border-light pt-2"
                    v-for="(item, index) in serviciosFiltered" :key="item.id"
                    :class="index === 0 ? '': 'border-top'"
                  >
                    <div class="col-sm-1">
                      <!-- <i
                        class="nav-icon i-Pen-5 text-success font-weight-bold"
                        style="cursor: pointer"
                        @click="showModalServicioInterno(item)"
                      >
                      </i> -->
                      <i class="nav-icon i-Close-Window text-danger font-weight-bold"
                        style="cursor: pointer"
                        v-if="!preCierre"
                        @click="eliminarServiciosInternos(item)"></i>
                      <i v-else
                        class="nav-icon i-Close-Window font-weight-bold"
                        style="cursor: pointer"
                        :title="messagePreCierre"
                      ></i>
                    </div>
                    <div class="col-sm-3">
                      {{item.venta_servicio_fecha}}
                      <br>
                      <b>User: </b> {{ item.usuario }}
                    </div>
                    <div class="col-sm-6">
                      {{item.tipo_servicio_nombre}}
                      <br>
                      <b>Glosa: </b> {{ item.textoglosa }}
                    </div>
                    <div class="col-sm-2 text-center">
                      {{item.hora}}
                    </div>
                  </div>
                </template>
                <template v-else>
                  <div
                    class="row mb-2 border-light pt-2 border-top">
                    <div class="col-sm-12 text-center">
                      No hay servicios internos registrados
                    </div>
                  </div>
                </template>
              </div>
            </div>
            <!-- servicios externos (CXP)-->
            <div class="row mb-2" v-show="nombreButtonActivo=='servicio_externo'">
              <div class="col-sm-12 rounded th-custom-color text-black py-2">
                <div class="row">
                  <div class="col-sm-1 font-weight-bold"> &nbsp;&nbsp;</div>
                  <div class="col-sm-3 p-0 font-weight-bold">Fecha</div>
                  <div class="col-sm-6 font-weight-bold">Servicios</div>
                  <div class="col-sm-2 font-weight-bold text-center">Hora</div>
                </div>
              </div>
              <div class="col-sm-12"
                :class="cuentas_x_pagar.length > 3? 'tabla-scroll-vertical': ''">
                <template v-if="cuentas_x_pagar.length > 0">
                  <div
                    class="row mb-2 border-light pt-2"
                    v-for="(item, index) in cuentas_x_pagar" :key="''+item.id + index"
                    :class="index === 0 ? '': 'border-top'">
                    <div class="col-sm-1">
                      <the-modal-servicio-externo
                        :data="dataModalCXP"
                        :editCxPIndex="index"
                        :havePreCierre="preCierre"
                        v-on:addCuentaPorPagar="editAddCuentaPorPagar"
                        :activateButton="nombreButtonActivo == 'servicio_externo' ? true : false"
                      /> &nbsp;&nbsp;
                      <i class="nav-icon i-Close-Window text-danger font-weight-bold"
                        v-if="!preCierre"
                        style="cursor: pointer"  @click="eliminarCuentaPorPagar(index)"></i>
                      <i v-else
                        class="nav-icon i-Close-Window font-weight-bold"
                        style="cursor: pointer"
                        :title="messagePreCierre"
                      ></i>
                    </div>
                    <div class="col-sm-3 p-0">
                      {{ getFechaFormat(item.fecha_deuda,'DD/MM/YYYY') }} <br>
                      {{item.usuario}}
                    </div>
                    <div class="col-sm-6 p-0">
                      {{item.origen_type}}: {{item.numero}} - Dr. {{item.medico}} -
                      <strong>Desc.: </strong>
                      {{item.glosa  ? item.glosa : item.descripcion}}
                    </div>
                    <div class="col-sm-2 text-center">
                      {{ getFechaFormat(item.created_at,'HH:mm')}}
                    </div>
                  </div>
                </template>
                <template v-else>
                  <div
                    class="row mb-2 border-light pt-2 border-top">
                    <div class="col-sm-12 text-center">
                      No hay servicios externos registrados
                    </div>
                  </div>
                </template>
              </div>
            </div>
            <!-- tabla laboratorio, ecografia, rayos x, tomografia, arco c -->
            <div
              class="row mb-2"
              v-if="
              categoriaServicioComplId === categoriaLaboratorio
              || categoriaServicioComplId === categoriaEcografia
              || categoriaServicioComplId === categoriaRayosX
              || categoriaServicioComplId === categoriaTomografia
              || categoriaServicioComplId === categoriaMamografia
              || categoriaServicioComplId === categoriaArcoC
                ">
              <div class="col-sm-12 px-0">
                <table class="table table-striped table-hover">
                  <thead>
                    <tr>
                      <th width="5%" class="th-custom-color text-center">N°</th>
                      <th width="20%" class="th-custom-color text-center">Categoria</th>
                      <th width="10%" class="th-custom-color text-center">Cant.</th>
                      <th width="20%" class="th-custom-color text-center">Servicios</th>
                      <th width="15%" class="th-custom-color text-center">Lista</th>
                      <th width="25%" class="th-custom-color text-center">Descripcion</th>
                      <th width="3%" class="th-custom-color text-center"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(servicio, index) in listTempServiciosComplementarios" :key="index">
                      <td class="text-center">{{ listTempServiciosComplementarios.length - index }} </td>
                      <td class="text-center">{{ servicio.categoria }}</td>
                      <td class="text-center">
                        <button
                        :class="{
                          'btn btnTurquesa': servicio.tipo_consumo_servicio === 1,
                          'btn btnBlue': servicio.tipo_consumo_servicio === 2
                        }"
                        >
                          {{servicio.cantidad}}
                        </button>
                      </td>
                      <td class="text-center">{{ servicio.nombre }}</td>
                      <td class="text-center">{{ servicio.precio }}</td>
                      <td class="text-center">
                        <input type="text"
                          v-model="servicio.descripcion"
                          class="form-control">
                      </td>
                      <td class="text-center">
                        <i
                          v-if="!preCierre"
                          class="nav-icon i-Close-Window text-danger font-weight-bold"
                          style="cursor: pointer"
                          @click="eliminarServicio(servicio)"
                        ></i>
                        <i v-else
                          class="nav-icon i-Close-Window font-weight-bold"
                          style="cursor: pointer"
                          :title="messagePreCierre"
                        ></i>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <!-- tabla para fisioterapia -->
            <div class="row mb-2"  v-if="categoriaServicioComplId === categoriaFisioterapia
            || categoriaServicioComplId === categoriaTratam"
            >
              <div class="col-sm-12 px-0">
                <table class="table table-striped table-hover">
                  <thead>
                    <tr>
                      <th width="5%" class="th-custom-color text-center">N°</th>
                      <th width="37%" class="th-custom-color text-center">Servicio</th>
                      <th width="20%" class="th-custom-color text-center">N° de Session</th>
                      <th width="15%" class="th-custom-color text-center">Lista</th>
                      <th width="35%" class="th-custom-color text-center">Descripción</th>
                      <th width="3%" class="th-custom-color text-center"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(servicio, index) in listTempServiciosComplementarios" :key="index">
                      <td class="text-center">{{ listTempServiciosComplementarios.length - index }} </td>
                      <td class="text-center">{{ servicio.categoria }} </td>
                      <td class="text-center">
                        <button
                        :class="{
                          'btn btnTurquesa': servicio.tipo_consumo_servicio === 1,
                          'btn btnBlue': servicio.tipo_consumo_servicio === 2
                        }"
                        >
                          {{servicio.session}}
                        </button>
                      </td>
                      <td class="text-center">{{ servicio.precio }}</td>
                      <td class="text-center">
                        <input type="text"
                          v-model="servicio.descripcion"
                          class="form-control">
                      </td>
                      <td class="text-center">
                        <i
                          v-if="!preCierre"
                          class="nav-icon i-Close-Window text-danger font-weight-bold"
                          style="cursor: pointer"
                          @click="eliminarServicio(servicio)"
                        ></i>
                        <i v-else
                          class="nav-icon i-Close-Window font-weight-bold"
                          style="cursor: pointer"
                          :title="messagePreCierre"
                        ></i>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <!-- tabla Evolución Médica -->
            <div class="row mb-2" v-show="nombreButtonActivo === 'evolucion_medica'">
              <div class="col-sm-12 px-0">
                <table class="table table-striped table-hover">
                  <thead>
                    <tr class="th-custom-color ">
                      <th class="py-2 text-center" width="5%">N°</th>
                      <th class="py-2 text-center" width="10%">Fecha</th>
                      <th class="py-2 text-center" width="10%">Hora</th>
                      <th class="py-2 text-center" width="24%">Descripción</th>
                      <th class="py-2 text-center" width="24%">Indicación</th>
                      <th class="py-2 text-center" width="24%">Médico</th>
                      <th width="3%" class="th-custom-color text-center"></th>
                      <th width="3%" class="th-custom-color text-center"></th>
                    </tr>
                  </thead>
                  <tbody class="text-center">
                    <tr v-for="(evolucion, index) in evolucionFiltered" :key="index">
                      <td class="text-center">{{ listTempServiciosComplementarios.length - index }} </td>
                      <td class="text-center"> {{ evolucion.fecha }} </td>
                      <td class="text-center"> {{ evolucion.hora }} </td>
                      <td class="text-center"> {{ evolucion.descripcion_medico }} </td>
                      <td class="text-center"> {{ evolucion.indicacion_medico }} </td>
                      <td class="text-center"> {{ evolucion.medico }} </td>
                      <td class="text-center">
                        <i
                          class="nav-icon i-File-Download font-weight-bold mr-3"
                          style="cursor: pointer"
                          @click="printReceta(evolucion)"
                        ></i>
                        <i v-if="evolucion.id !== 0"
                          class="nav-icon i-Receipt-3 font-weight-bold"
                          style="cursor: pointer"
                          @click="selectItem(evolucion)"
                        ></i>
                      </td>
                      <td class="text-center">
                        <i
                          class="nav-icon i-Close-Window font-weight-bold text-danger"
                          style="cursor: pointer"
                          @click="eliminarEvolucionMedica(evolucion)"
                        ></i>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
    <TheModalAutorizacionInternacion
      :dataPaciente="dataPaciente"
      :autorizacion="autorizacionData"
      :isEdit="true"
      @autorizacion-guardada="manejarAutorizacion"
    />
    <TheModalServicios
      :titleModal="nombreButtonActivo"
      :isInternation="isInternation"
      @addServiciosComplemetarios="addServiciosComplemetarios"
      @setTipoConsumoProducto="setTipoConsumoProducto"
      :seguro="seguro.model"
      :moneda="moneda"
      :hasActiveEvolucionMedica="hasActiveEvolucionMedica"
      :has_active_receta="has_active_receta"
      :has_active_insumo="has_active_insumo"
      :has_active_venta="has_active_venta"
    />
    <TheModalFisioterapia
      :titleModal="nombreButtonActivo"
      :isInternation="isInternation"
      @addServiciosComplemetarios="addServiciosComplemetarios"
      @setTipoConsumoProducto="setTipoConsumoProducto"
      :seguro="seguro.model"
      :moneda="moneda"
      :hasActiveEvolucionMedica="hasActiveEvolucionMedica"
    />
    <TheModalMedicalIndicationEnfermeria :isInternacion="true"/>
    <TheModaSignoVitales
    @addSignosVitales="addSignosVitales"/>
    <modalNotificacionSeguro
    :mostrar="mostrarModal"
      @cerrar="cerrarModal"
    />
    <TheModalAntecedente v-if="pacienteSelected"
    :internacion="true"
    :idPaciente="pacienteSelected.id"
    @addAntecedentes="addAntecedentes($event)"/>
    <!-- Modal Descuentos -->
    <TheModalDescuentos
      ref="modalDescuentos"
      :servicioComplementario="servicioComplementario"
      :diasTratamiento="diasTratamiento"
      :fechaInicio="fecha"
      @guardarDescuentos="onGuardarDescuentos"
    />
  </div>
  </div>
</template>

<script>
import store from '@/store/index';
import Multiselect2 from '@/components/util/vue-multiselect2';
import DatePicker from 'vue2-datepicker';
import axios from '@/modules/common/axiosERP';
import moment from 'moment';
import { util } from '@/plugins/util';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/es';
import { mapFields } from 'vuex-map-fields';
import {
  mapActions, mapGetters, mapMutations,
} from 'vuex';
import {
  CATEGORIA_SERVICIO_COMPL,
  TIPO_CONSUMO_PRODUCTO_SERVICIO,
  TIPO_BUTTON_ADMISION,
  MODULOS,
} from '@/utils/globalConventions';
import ComboPaciente from '../components/ThePatient.vue';
import ModalPacienteNuevo from '../../facturacion/components/TheNuevoPacienteModal.vue';
import ModalPieza from '../components/TheModalPieza.vue';
import TheModalServicioExterno from '../components/TheModalServicioExterno.vue';
import TheModalConsumoProductos from '../components/TheModalConsumoProductos.vue';
import TheModalServicioInterno from '../components/TheModalServicioInterno.vue';
import TheModalPreCierre from '../components/TheModalPreCierre.vue';
import ModalCierre from '../components/TheModalCierre.vue';
import TheModalServicios from '../../asistenciaMedico/components/TheModalServicios.vue';
import TheModalFisioterapia from '../../asistenciaMedico/components/TheModalFisioterapia.vue';
import QuirofanoItem from '../components/QuirofanoItem.vue';
import TheModalCirugia from '../components/TheModalCirugia.vue';
import TheModalEvolucionMedica from '../components/TheModalEvolucionMedica.vue';
import TheModalInterConsulta from '../components/TheModalInterConsulta.vue';
import TheModalAutorizacionInternacion from '../components/TheModalAutorizacionInternacion.vue';
import ComboDiagnostic from '../components/TheDiagnostic.vue';
import TheModalMedicalIndicationEnfermeria from '../components/TheModalMedicalIndication.vue';
import hojaAdmision from '../components/ModalHojaAdmision.vue';
import TheModaSignoVitales from '../../asistenciaMedico/components/TheModaSignoVitales.vue';
import historialClinicaInternacion from '../components/historialClinicaInternacion.vue';
import modalNotificacionSeguro from '../components/modalNotificacionSeguro.vue';
import TheModalAntecedente from '../../asistenciaMedico/components/TheModalAntecedente.vue';
import TheModalDescuentos from '../components/TheModalDescuentos.vue';

export default {
  name: 'edit',
  components: {
    Multiselect2,
    DatePicker,
    ComboPaciente,
    ModalPacienteNuevo,
    ModalPieza,
    TheModalServicioExterno,
    TheModalConsumoProductos,
    TheModalServicioInterno,
    TheModalPreCierre,
    ModalCierre,
    TheModalServicios,
    TheModalFisioterapia,
    QuirofanoItem,
    TheModalCirugia,
    TheModalEvolucionMedica,
    TheModalInterConsulta,
    TheModalAutorizacionInternacion,
    ComboDiagnostic,
    TheModalMedicalIndicationEnfermeria,
    hojaAdmision,
    TheModaSignoVitales,
    historialClinicaInternacion,
    modalNotificacionSeguro,
    TheModalAntecedente,
    TheModalDescuentos,
  },
  data() {
    return {
      id: atob(this.$route.params.id),
      isLoading: true,
      fecha: null,
      pacienteSelected: null,
      pacientes: [],
      servicios: [],
      isInternation: true,
      fechaCierre: new Date(),
      categoriaTratamiento: {
        listaCategorias: [],
        model: null,
      },
      medico: {
        listaMedicos: [],
        model: [],
      },
      seguro: {
        listaSeguros: [],
        model: null,
      },
      almacen: {
        listaAlmacenes: [],
        model: null,
      },
      numero: '',
      edit: true,
      dataPaciente: {},
      confirmacioAutorizacion: false,
      autorizacionData: {
        id: 0, // 0 para nuevo, número real para edición
        nombre: '',
        ci: '',
        parentesco: '',
        is_manual: true, // Siempre manual ahora
      },
      edad: '',
      mes: '',

      // CXP
      moneda: {
        model: null,
        multiselect: [],
        nuevo_tipo_cambio: null,
        tc_secundario: null,
      },
      cxp: {},
      dataModalCXP: {},
      cuentas_x_pagar: [],
      cuentas_x_pagar_origin: [],

      // Consumo Productos SP
      consumoProductos: [],
      salidaProductos: {
        total: 0,
        detalles: [],
      },
      sugerencias_glosas_sp: [],
      productosEdit: [],

      sugerencias_glosas: [],
      servicios_origin: [],
      serviciosAllInternos: [],
      // anticipo: 0,
      preCierre: false,
      categoriaServiciosInternos: [],
      preCierreData: {
        id: null,
        total_precierre: 0,
        saldo_precierre: 0,
        anticipo_precierre: 0,
        glosa_precierre: null,
        estado_precierre: false,
        custom_id: null,
        fecha: null,
        hora: null,
        usuario: null,
        first_fecha_precierre: null,
        first_precierre_tratamiento: false,
        first_precierre_tratamiento_edit: false,
      },
      cierre: {
        fecha: null,
        hora: null,
        glosa: null,
        estado: false,
      },
      empresa_moneda: null,
      messagePreCierre: 'Acción no permita usted tiene un precierre',
      isDisableSeguro: store.getters['main/hasPermisionListarSeguro'],
      buttonDisable: false,
      modeAddItem: false,
      cirugias: [
        {
          id: 1,
          modeAddCirugia: false,
        },
      ],
      nombreButtonActivo: '',
      labelTratamiento: 'label',
      listaClasificacionCIE: [],
      categoriaServicioComplId: null,
      servicioComplementario: [],
      descuento_gral: 0,
      no_aplicar_en_venta: 0,
      descuento_monto: 0,
      diagnostico: '',
      medicationsProvidesByPharmacy: null, // false es rechazado y true es confirmado, null es no selecciono nada
      parametroServicioComplementarioList: [],
      tipo_consumo_producto: null,
      listTempServiciosComplementarios: [],
      evolucionMedicas: [],
      hasActiveEvolucionMedica: false,
      hasActiveServicioExt: false,
      hasActiveServicioInt: false,
      listaClasificacionCIEFiltrada: [],
      diagnosticoSeleccionado: null, // Inicialmente null
      diasTratamiento: 0,
      datoPieza: null,
      tipoTratamientoId: null,
      camasDiasGuardados: {},
      diasCargadosSalaCama: [],
      detalle_sala_camas: [],
      isLoadingTratamiento: false,
      has_active_receta: false,
      has_active_insumo: false,
      has_active_venta: false,
      has_Admision: false,
      responsable_paciente: null,
      familiar_id: null,
      tipoViaAdministracions: [],
      signosVitales: [],
      tipoSeguro: [],
      tipoSeguroSeleccionado: null,
      total: 0,
      contactoPacienteId: null,
      medicoInterConsulta: null,
      activeHC: false,
      pacienteTemporal: null,
      seguroTemporal: null,
      diagnosticoTemporal: null,
      has_active_hc: false,
      historialClinico: [
      ],
      numero_internacion: null,
      fecha_ingreso: null,
      hora_ingreso: null,
      mostrarModal: false,
      modalPermanenteCerrado: false,
      hasActiveDerechoAdmi: false,
      antecedentesInternacion: [],
      listaAntecedentes: {},
      has_tratamiento_farmacia_mecicamento: false,
    };
  },
  async created() {
    this.cargarDatosIniciales();
    await this.getParametrosConsultaExterna();
    this.detectAndSetComponentActive();
    this.cargarDatosInicialesHC();
    this.isActiveHC();
    if (this.seguro.model) {
      this.verificarTotal();
    }
  },
  beforeDestroy() {
    this.resetModalPieza();
    this.resetTheDiagnosticData();
    this.resetModalHojaAdminision();
    this.resetTheModalInterConsulta();
  },
  methods: {
    validarButton() {
      return this.datoPieza !== null;
    },
    async cargarDatosInicialesHC() {
      try {
        const RESPONSE = await axios.get('clinic/tratamientos/historial_clinico', {
          params: { tratamiento_id: this.id },
        });
        this.numero_internacion = RESPONSE.data.data.numero_internacion;
        this.fecha_ingreso = RESPONSE.data.data.fecha_ingreso;
        this.hora_ingreso = RESPONSE.data.data.hora_ingreso;
        this.historialClinico = RESPONSE.data.data.historial_clinico;
      } catch (error) {
        util.showNotify(error.response.data.message, 'error');
      }
    },
    async cargarDatosIniciales() {
      this.isLoading = true;
      try {
        const RESPONSE = await axios.get(`clinic/tratamientos/${this.id}/edit`);
        const DATA_TRATAMIENTOS = RESPONSE.data.data.data_tratamientos;
        const nombreParametroTratamiento = RESPONSE.data.data.nombre_parametro_consulta_externa;
        this.labelTratamiento = nombreParametroTratamiento?.nombre_tratamiento_principal ?? '';
        this.categoriaTratamiento.listaCategorias = RESPONSE.data.data.categoria_tratamientos;
        this.medico.listaMedicos = RESPONSE.data.data.medicos;
        this.seguro.listaSeguros = RESPONSE.data.data.seguros;
        this.almacen.listaAlmacenes = RESPONSE.data.data.almacens;
        this.fecha = new Date(moment(DATA_TRATAMIENTOS.fecha));
        this.fechaCierre = new Date(moment(DATA_TRATAMIENTOS.fecha_cierre));
        this.numero = DATA_TRATAMIENTOS.numero;
        this.pacienteSelected = RESPONSE.data.data.paciente;
        this.dataPaciente = RESPONSE.data.data.paciente;
        this.edad = this.dataPaciente.edad;
        this.mes = this.dataPaciente.meses;
        this.medico.model = RESPONSE.data.data.tratamiento_medicos;
        this.seguro.model = this.seguro.listaSeguros.find((ele) => (
          ele.id === DATA_TRATAMIENTOS.seguro_id));
        this.almacen.model = this.almacen.listaAlmacenes.find((ele) => (
          ele.id === DATA_TRATAMIENTOS.almacen_id));
        this.categoriaTratamiento.model = RESPONSE.data.data.detalle_categorias_tratamientos;
        this.isLoadingTratamiento = true;
        this.datoPieza = DATA_TRATAMIENTOS.sala_cama_id;
        this.tipoTratamientoId = DATA_TRATAMIENTOS.tipo_tratamiento_id ?? null;
        const SALA_CAMA = this.dataSalaCama(DATA_TRATAMIENTOS);
        this.cargarSalaEdit(SALA_CAMA);
        this.detalle_sala_camas = RESPONSE.data.data.detalle_sala_camas || [];
        if (DATA_TRATAMIENTOS.sala_cama_id) {
          try {
            const resDias = await axios.post(
              `clinic/tratamientos/store/detalle_dia_sala_cama/${this.id}`,
              { sala_cama_id: DATA_TRATAMIENTOS.sala_cama_id },
            );
            this.diasCargadosSalaCama = resDias.data.data.data || [];
          } catch (e) { /* sin días cargados */ }
        }
        // carga datos Modal cxp
        this.moneda.multiselect = RESPONSE.data.data.monedas;
        this.moneda.model = this.loadMonedaPrincipal(this.moneda.multiselect);
        // this.dataModalCXP.medicos = this.medico.listaMedicos;
        this.dataModalCXP.medicos = RESPONSE.data.data.medicos;
        this.dataModalCXP.monedas = this.moneda;
        this.dataModalCXP.parametrosContables = RESPONSE.data.data.pametrosContables;
        this.dataModalCXP.tipo_comprobantes = RESPONSE.data.data.tipo_comprobante
          .filter((ele) => (ele.id === 1 || ele.id === 4));
        this.dataModalCXP.cuenta_credito_fiscal = RESPONSE.data.data.cuenta_credito_fiscal;
        this.cuentas_x_pagar = RESPONSE.data.data.cuentas_x_pagar;
        this.cuentas_x_pagar.forEach((item, index) => {
          this.cuentas_x_pagar[index].importe_neto = item.importe_s_d - item.descuento;
          this.cuentas_x_pagar[index].importe = item.importe_s_d;
        });
        this.cuentas_x_pagar_origin = this.cloneObject(RESPONSE.data.data.cuentas_x_pagar);
        this.dataModalCXP.tipoFacturas = RESPONSE.data.data.tipo_facturas;
        this.dataModalCXP.cuentas_x_pagar = this.cuentas_x_pagar;

        // Consumo Productos SP
        this.consumoProductos = RESPONSE.data.data.consumo_productos;
        this.sugerencias_glosas_sp = RESPONSE.data.data.sugerencia_glosas_consumo_productos;
        if (this.consumoProductos.length > 0) {
          this.cargarConsumoProductos();
          this.productosEdit = this.cloneObject(this.consumoProductos);
        }
        this.servicioComplementario = RESPONSE.data.data.servicios_complementarios;
        this.servicioComplementario.forEach((el, index) => {
          this.servicioComplementario[index].estado = el.estado === 1;
        });
        this.descuento_gral = DATA_TRATAMIENTOS.descuento_gral || 0;
        this.no_aplicar_en_venta = DATA_TRATAMIENTOS.no_aplicar_en_venta || 0;
        this.descuento_monto = DATA_TRATAMIENTOS.descuento_monto || 0;
        this.servicios = RESPONSE.data.data.tratamiento_venta_servicios;
        this.sugerencias_glosas = RESPONSE.data.data.sugerencia_glosas;
        this.serviciosAllInternos = RESPONSE.data.data.tipo_servicios;
        this.categoriaServiciosInternos = RESPONSE.data.data.categoria_medico;
        this.cargarModalPreCierre(RESPONSE.data.data.preCierre);
        this.setServicesData();
        this.empresa_moneda = RESPONSE.data.data.empresa_moneda;
        this.listaClasificacionCIE = RESPONSE.data.data.clasificacion_cies;
        // this.clasificacionCIE = this.listaClasificacionCIE.find((el) => (
        //   el.id === DATA_TRATAMIENTOS.clasificacion_cie1_id
        // ));
        // this.clasificacionObtenida(DATA_TRATAMIENTOS);
        this.diagnosticoSeleccionado = RESPONSE.data.data.diagnostico_seleccionado;
        this.diagnostico = DATA_TRATAMIENTOS.diagnostico1;
        this.evolucionMedicas = RESPONSE.data.data.evolucion_medica;
        this.hasActiveEvolucionMedica = RESPONSE.data.data.has_active_evolucion_medica;
        this.hasActiveServicioExt = RESPONSE.data.data.has_active_servicio_ext;
        this.hasActiveServicioInt = RESPONSE.data.data.has_active_servicio_int;
        this.diasTratamiento = RESPONSE.data.data.dias_tratamiento;
        this.responsable_paciente = RESPONSE.data.data.responsable_paciente;
        this.tipoViaAdministracions = RESPONSE.data.data.tipo_via_administracions_farmacos;
        this.total = parseInt(DATA_TRATAMIENTOS.acumulado_seguro, 10);
        this.tipo_seguro_id = DATA_TRATAMIENTOS.clasificacion_seguro_id;
        this.getTipoSeguro();

        // Cargar datos de autorización si existen
        if (!RESPONSE.data.data.autorizacion) {
          this.medicationsProvidesByPharmacy = false;
        } else {
          this.cargarDatosAutorizacion(DATA_TRATAMIENTOS, RESPONSE.data.data.autorizacion);
        }

        // eslint-disable-next-line no-empty
        if (this.responsable_paciente !== null) {
          this.has_Admision = true;
          this.familiar_id = this.responsable_paciente.familiar_id;
          this.contactoPacienteId = this.responsable_paciente.contacto_paciente_id;
        }
        const SIGNOS_VITALES = RESPONSE.data.data.signos_vitales;
        if (SIGNOS_VITALES.length > 0) {
          this.cargarDataSignoVitales(SIGNOS_VITALES[0]);
          // eslint-disable-next-line prefer-destructuring
          this.signosVitales.push(SIGNOS_VITALES[0]);
        }
        this.medicoInterConsulta = RESPONSE.data.data.medico_interconsulta;
        const INTERCONSULTAS = RESPONSE.data.data.interconsultas;
        this.setEditInterConsulta(INTERCONSULTAS);
        const { data } = RESPONSE.data;
        this.$store.dispatch('theModalAntecedente/actualizarAntecedentes', {
          t_alcohol: data.t_alcohol,
          t_cirugia: data.t_cirugia,
          t_dieta: data.t_dieta,
          t_medicamento: data.t_medicamento,
          t_ocupacion: data.t_ocupacion,
          t_patologia: data.t_patologia,
          t_psicosocial: data.t_psicosocial,
          t_tabaco: data.t_tabaco,
          t_vivienda: data.t_vivienda,
          t_actividad_fisica: data.t_vivienda,
        });
      } catch (error) {
        util.showNotify(error.response.data.message, 'error');
      } finally {
        this.isLoading = false;
        this.$nextTick(() => { this.isLoadingTratamiento = false; });
      }
    },
    async isActiveHC() {
      try {
        const response = await axios.get('/clinic/parametros/other/create');
        this.has_active_hc = response.data.data.has_active_tratamiento_historial_clinico;
        this.hasActiveDerechoAdmi = response.data.data.has_active_tratamiento_derecho_admision;
        this.has_tratamiento_farmacia_mecicamento = response.data.data.has_tratamiento_farmacia_mecicamento;
      } catch (error) {
        util.showNotify(error.response.data.message, 'error');
      }
    },
    dataSalaCama(data) {
      const ITEM = {
        cama_nombre: data.cama_nombre,
        clase_nombre: data.clase_nombre,
        estado: data.estado,
        fecha: data.fecha,
        sala_cama_id: data.sala_cama_id,
        medico: data.medico,
        numero: data.numero,
        piso_sala_nombre: data.piso_sala_nombre,
        tratamiento: data.tratamiento,
        checkInput: true,
        derecho_admision: data.derecho_admision,
        importe_x_dia: data.importe_x_dia,
        motivo: data.motivo,
        tiempo: data.tiempo,
      };
      return ITEM;
    },
    async getParametrosConsultaExterna() {
      try {
        const response = await axios.get('/clinic/servicio_complementario/nombre_parametro_servicio_consulta/create');
        const parametro2 = response.data.data.nombre_parametro_servicio_complementario;
        this.has_active_receta = response.data.data.has_active_receta;
        this.has_active_insumo = response.data.data.has_active_insumo;
        this.has_active_venta = response.data.data.has_active_venta;
        if (parametro2.length !== 0) {
          this.parametroServicioComplementarioList = parametro2;
        }
      } catch (error) {
        util.showNotify(error.response.data.message, 'error');
      }
    },
    detectAndSetComponentActive() {
      if (this.isActiveFarmacia) {
        this.nombreButtonActivo = 'productos';
        return;
      }
      if (this.isActiveLaboratorio) {
        this.nombreButtonActivo = 'Laboratorio';
        return;
      }
      if (this.isActiveEcografia) {
        this.nombreButtonActivo = 'Ecografia';
        return;
      }
      if (this.isActiveRayosX) {
        this.nombreButtonActivo = 'Rayos_X';
        return;
      }
      if (this.isActiveTomografia) {
        this.nombreButtonActivo = 'Tomografia';
        return;
      }
      if (this.isActiveMamografia) {
        this.nombreButtonActivo = 'Mamografia';
        return;
      }
      if (this.isActiveArcoC) {
        this.nombreButtonActivo = 'arco_c';
        return;
      }
      if (this.isActiveFisioterapia) {
        this.nombreButtonActivo = 'fisioterapia';
        this.nombreButtonActivo = 'Fisioterapia';
        return;
      }
      if (this.isActiveTratamiento) {
        this.nombreButtonActivo = 'Tratamiento';
        return;
      }
      this.nombreButtonActivo = '';
    },
    openModalPaciente() {
      this.$bvModal.show('modal-nuevoPaciente');
    },
    formatearDate(fecha) {
      const dat = new Date(fecha);
      return new Date(dat.setDate(dat.getDate() + 1));
    },
    AddPaciente(paciente) {
      if (paciente) {
        // this.$refs.theModalPreCierre.restaurar();
        this.preCierre = false;
        this.dataPaciente = paciente.datosPaciente;
        this.edad = (paciente.datosPaciente.edad) ? `${paciente.datosPaciente.edad} años` : '0 años';
        this.mes = (paciente.datosPaciente.meses) ? `${paciente.datosPaciente.meses} mes` : '0 mes';
        // this.showCortinaInformativa = true;
        this.pacienteSelected = paciente.pacienteSelect;
        this.preCierreData.anticipo_precierre = (this.dataPaciente.anticipo)
          ? this.dataPaciente.anticipo : 0;
      } else {
        this.edad = '';
        this.mes = '';
        // this.showCortinaInformativa = false;
        this.pacienteSelected = '';
        this.dataPaciente = '';
      }
    },
    async update() {
      if (this.buttonDisable) return;
      if (this.validar()) {
        this.buttonDisable = true;
        this.isLoading = true;
        if (this.getIDItemChecked && Object.keys(this.camasDiasGuardados).length === 0) {
          try {
            const response = await axios.post(
              `clinic/tratamientos/store/detalle_dia_sala_cama/${this.id}`,
              { sala_cama_id: this.getIDItemChecked },
            );
            const diasCargados = response.data.data.data || [];
            if (diasCargados.length > 0) {
              this.detalle_sala_camas = diasCargados.map((dia) => ({
                id: dia.id,
                estado: dia.estado !== 0 && dia.estado !== false,
              })).filter((d) => d.id);
            }
          } catch (error) {
            util.showNotify(error?.response?.data?.message ?? 'Error al cargar días de cama', 'error');
          }
        }
        this.preCierreData.estado_precierre = this.preCierre;
        this.cargarDatosPreCierre();
        const derechoAdmi = this.hasActiveDerechoAdmi === true ? this.getImporteXDiaSalaCama : null;
        const DATA = {
          descuento_gral: this.descuento_gral,
          no_aplicar_en_venta: this.no_aplicar_en_venta,
          descuento_monto: this.descuento_monto,
          paciente_id: this.pacienteSelected.id,
          fecha: moment(this.fecha).format('YYYY-MM-DD'),
          fecha_cierre: moment(this.fechaCierre).format('YYYY-MM-DD'),
          almacen_id: (this.almacen.model) ? this.almacen.model.id : null,
          seguro_id: (this.seguro.model) ? this.seguro.model.id : '',
          clasificacion_seguro_id: this.tipo_seguro_id,
          acumulado_seguro: this.total,
          tratamiento_medicos: this.medico.model,
          categoria_tratamientos: this.categoriaTratamiento.model,
          monedas: this.moneda.multiselect,
          cuentas_x_pagar: this.cuentasPorPagarSendData(),
          sala_cama_id: this.getIDItemChecked,
          detalle_sala_camas: this.detalle_sala_camas,
          derecho_admision: derechoAdmi,
          sala_cama_precio: this.getImporteXDiaSalaCama,
          venta_servicios: this.clearParams(),
          consumo_productos: this.salidaProductosSendData(),
          preCierre: this.preCierreData,
          cierre: this.cierre,
          clasificacion_cie_id: this.diagnosticoSeleccionado?.id ?? null,
          subclasificacion_cie_id: this.diagnosticoSeleccionado?.id_sub ?? null,
          nombre_diagnostico: this.diagnostico,
          detalles_cirugias: [],
          servicios_complementarios: this.servicioComplementario,
          evolucion_medica: this.evolucionMedicas,
          dias_tratamiento: this.diasTratamiento,
          estado_cama_id: 1,
          familiar_id: this.familiar_id,
          contacto_paciente_id: this.contactoPacienteId,
          signos_vitales: this.signosVitales,
          interconsultas: this.clearInterConsultas(),
          historial_clinico: this.historialClinico,
          antecedente: {
            id: this.listaAntecedentes.id,
            tipo_dieta_id: this.listaAntecedentes.tipoDietaSelected ? this.listaAntecedentes.tipoDietaSelected.id : null,
            tipo_vivienda_id: this.listaAntecedentes.tipoViviendaSelected ? this.listaAntecedentes.tipoViviendaSelected.id : null,
            tipo_tabaco_id: this.listaAntecedentes.tipoTabacoSelected ? this.listaAntecedentes.tipoTabacoSelected.id : null,
            tipo_alcohol_id: this.listaAntecedentes.tipoAlcohosSelected ? this.listaAntecedentes.tipoAlcohosSelected.id : null,
            f_inicio_tabaco: this.formattedDateAntecedent(this.listaAntecedentes.fechaInicio),
            f_inicio_alcohol: this.formattedDateAntecedent(this.listaAntecedentes.fechaInicio2),
            tipo_medicamento_id: this.listaAntecedentes.tipoMedicamentoSelected ? this.listaAntecedentes.tipoMedicamentoSelected.id : null,
            tipo_actividad_fisica_id: this.listaAntecedentes.tipoActividadFisicaSelected ? this.listaAntecedentes.tipoActividadFisicaSelected.id : null,
            tipo_ocupacion_id: this.listaAntecedentes.tipoOcupacionSelected ? this.listaAntecedentes.tipoOcupacionSelected.id : null,
            tipo_psicosocial_id: this.listaAntecedentes.tipoPsicosocialSelected ? this.listaAntecedentes.tipoPsicosocialSelected.id : null,
            cardiovasculares: this.listaAntecedentes.cardiovasculares,
            alergias: this.listaAntecedentes.alergias,
            otros: this.listaAntecedentes.descripcionOtros,
          },
          patologias_antecedente: this.obtenerPatologiasAntecedente(),
          cirugias_antecedente: this.obtenerCirugiasAntecedente(),
          confirmacion_autorizacion: this.confirmacioAutorizacion,
          autorizacion: {
            id: this.autorizacionData.id,
            nombre: this.autorizacionData.nombre,
            ci: this.autorizacionData.ci,
            parentesco: this.autorizacionData.parentesco,
            is_manual: this.autorizacionData.is_manual,
          },
        };
        this.buttonDisable = true;
        axios.put(`clinic/tratamientos/update/${this.id}`, DATA)
          .then((response) => {
            util.showNotify(response.data.message, 'success');
            this.$router.push('/internacion');
          })
          .catch((error) => {
            const FALLO_VALIDACION = 422;
            if (error.response.status !== FALLO_VALIDACION) {
              util.showNotify(error.response.data.message, 'error');
            } else {
              Object.entries(error.response.data.data).forEach(([, mensajes]) => {
                mensajes.forEach((texto) => util.showNotify(texto, 'error'));
              });
            }
          })
          .finally(() => {
            this.buttonDisable = false;
            this.isLoading = false;
          });
      }
    },
    clearParams() {
      this.servicios.forEach((e, index) => {
        delete this.servicios[index].customId;
        delete this.servicios[index].usuario;
        delete this.servicios[index].textoglosa;
        delete this.servicios[index].tipo_servicio_nombre;
      });
      return this.servicios;
    },
    obtenerPatologiasAntecedente() {
      return this.listaAntecedentes.patologias.length > 0
        ? this.listaAntecedentes.patologias.map((patologia) => ({
          id: patologia.id || null,
          descripcion: patologia.descripcion,
          estado: patologia.tipoPatologiaSelected?.estado
            ? patologia.tipoPatologiaSelected.estado === '1' || patologia.tipoPatologiaSelected.estado === true
            : false,
          tipo_patologia_id: patologia.tipoPatologiaSelected?.id || null,
        }))
        : [];
    },

    obtenerCirugiasAntecedente() {
      return this.listaAntecedentes.cirugias.length > 0
        ? this.listaAntecedentes.cirugias.map((cirugia) => ({
          id: cirugia.id || null,
          descripcion: cirugia.descripcion,
          estado: cirugia.tipoCirugiaSelected?.estado
            ? cirugia.tipoCirugiaSelected.estado === '1' || cirugia.tipoCirugiaSelected.estado === true
            : false,
          tipo_cirugia_id: cirugia.tipoCirugiaSelected?.id || null,
        }))
        : [];
    },
    validar() {
      let validate = true;
      if (!this.pacienteSelected) {
        util.showNotify('Seleccione un paciente', 'warn');
        validate = false;
      }
      if (!this.fecha) {
        util.showNotify('La fecha es un campo obligatorio', 'warn');
        validate = false;
      }
      if (!this.fechaCierre) {
        util.showNotify('La fecha de cierre es un campo obligatorio', 'warn');
        validate = false;
      }
      if ((this.consumoProductos.length > 0 || this.cuentas_x_pagar_origin.length > 0)
        && !this.almacen.model) {
        util.showNotify('Debe seleccionar un almacen. \n Si va registrar Consumo Productos o Servicios Externos', 'warn');
        validate = false;
      }
      if (this.medico.model.length === 0) {
        util.showNotify('Selecciones un medico', 'warn');
        validate = false;
      }
      if (!this.categoriaTratamiento.model) {
        util.showNotify('Seleccione un tratamiento', 'warn');
        validate = false;
      }
      if (!this.diagnosticoSeleccionado) {
        util.showNotify('Seleccione un Diagnóstico', 'warn');
        validate = false;
      }
      if (this.fecha && this.fechaCierre) {
        if (this.fecha.getTime() > this.fechaCierre.getTime()) {
          util.showNotify('La fecha de cierre debe ser mayor que la fecha inicio', 'error');
          validate = false;
        }
      }
      return validate;
    },
    ...mapActions('theModalServicios', [
      'resetDataTheModaServios',
      'getDataServicioComplementario',
    ]),
    addCuentaPorPagar(cuentaPorPagar) {
      const cxpObj = JSON.stringify(cuentaPorPagar);
      this.cxp = JSON.parse(cxpObj);
      this.cuentas_x_pagar.push(this.cxp);
      // this.$refs.theModalPreCierre.restaurar();
    },
    loadMonedaPrincipal(monedas) {
      for (let i = 0; i < monedas.length; i += 1) {
        if (monedas[i].is_principal === 1) {
          return monedas[i];
        }
      }
      return null;
    },
    transformCXPEdit(cxp) {
      const cxpNew = {
        id: (cxp.id) ? cxp.id : 0,
        persona_id: cxp.medico.persona_id,
        medico: cxp.medico.nombre,
        numero: cxp.numero,
        origen_type: cxp.origen_type,
        tipo_comprobante_id: cxp.tipo_comprobante.id,
        comprobante: cxp.t_comprobante_child,
        pre_retencion_tipo_id: (cxp.preRetencionTipo) ? cxp.preRetencionTipo.id : null,
        nuevo_tipo_cambio: cxp.nuevo_tipo_cambio,
        fecha_deuda: cxp.fecha,
        moneda_id: cxp.moneda.id,
        cuenta_contable_id: cxp.cuenta_pasivo_id,
        cuenta_contable_gasto_id: cxp.cuenta_gasto_id,
        descripcion: cxp.glosa,
        importe: cxp.importe,
        retencion: cxp.retencion,
        importe_neto: cxp.importe_neto,
        descuento: cxp.descuento,
        fecha_vencimiento: cxp.fecha_vencimiento,
        factura: (cxp.tipo_comprobante.id === 1) ? cxp.factura : null,
        index: cxp.index,
        usuario: cxp.usuario,
        created_at: cxp.created_at,
        importe_actual: cxp.importe_actual,
      };
      if (cxp.id && cxp.id > 0) {
        cxpNew.editable = true;
      }
      return cxpNew;
    },
    editAddCuentaPorPagar(cuentaPorPagar) {
      const cxpEdit = this.transformCXPEdit(cuentaPorPagar);
      this.cxp = this.cloneObject(cxpEdit);
      this.agregarCuentasPorPagar(this.cxp);
    },
    eliminarCuentaPorPagar(index) {
      const cxpDel = this.cuentas_x_pagar[index];
      const indexReal = this.cuentas_x_pagar_origin.findIndex((ele) => (ele.id === cxpDel.id));
      if (cxpDel.id > 0) {
        delete this.cuentas_x_pagar_origin[indexReal].editable;
        this.cuentas_x_pagar_origin[indexReal].eliminar = true;
      } else {
        this.cuentas_x_pagar_origin.splice(indexReal, 1);
      }
      this.cuentas_x_pagar.splice(index, 1);
    },
    agregarCuentasPorPagar(cxp) {
      if (cxp.index >= 0) {
        // let index = cxp.index;
        this.cuentas_x_pagar.splice(cxp.index, 1, cxp);
        const indexReal = this.cuentas_x_pagar_origin.findIndex((ele) => (ele.id === cxp.id));
        this.cuentas_x_pagar_origin.splice(indexReal, 1, cxp);
      } else {
        this.cuentas_x_pagar.push(this.cxp);
        this.cuentas_x_pagar_origin.push(this.cxp);
      }
    },
    cuentasPorPagarSendData() {
      const cxps = [];
      this.cuentas_x_pagar_origin.forEach((cxp) => {
        cxps.push({
          id: cxp.id,
          persona_id: cxp.persona_id, // 24002,
          t_comprobante_id: cxp.tipo_comprobante_id,
          t_comprobante_child: cxp.comprobante,
          pre_retencion_tipo_id: (cxp.preRetencionTipo) ? cxp.preRetencionTipo.id : null,
          nuevo_tipo_cambio: (cxp.nuevo_tipo_cambio) ? cxp.nuevo_tipo_cambio : null,
          fecha: cxp.fecha_deuda,
          fecha_hora: this.getFechaFormat(cxp.created_at, 'YYYY-MM-DD HH:mm:ss'),
          moneda_id: cxp.moneda_id,
          cuenta_pasivo_id: cxp.cuenta_contable_id,
          cuenta_gasto_id: cxp.cuenta_contable_gasto_id,
          descripcion: cxp.descripcion,
          importe: cxp.importe,
          retencion: cxp.retencion,
          importe_neto: (cxp.importe_neto) ? cxp.importe_neto : cxp.importe,
          descuento: cxp.descuento,
          sucursal_id: (cxp.sucursal_id) ? cxp.sucursal_id : null,
          fecha_vencimiento: cxp.fecha_vencimiento,
          factura: ((cxp.tipo_comprobante_id === 1)) ? cxp.factura : null,
          editar: cxp.editable,
          eliminar: cxp.eliminar,
          tributo_id: cxp.tributo_id ? cxp.tributo_id : null,
          importe_actual: cxp.importe_actual,
        });
      });
      return cxps;
    },
    cloneObject(object) {
      const objectString = JSON.stringify(object);
      return JSON.parse(objectString);
    },
    getFechaFormat(dateString, formato) {
      return moment(dateString).format(formato);
    },
    addProducto(detalles) {
      const productoObj = this.cloneObject(detalles);
      this.salidaProductos.detalles = [];
      this.consumoProductos = [];
      for (let index = 0; index < productoObj.length;) {
        const ele = productoObj[index];
        index += 1;
        let importe = 0;
        if (ele.importe === null || typeof ele.importe === 'undefined') {
          if (ele.tipo_consumo === 1) {
            importe = ele.cantidad * ele.costo_unitario;
          } else if (ele.tipo_consumo === 2) {
            importe = ele.cantidad * ele.producto_precio;
          }
        } else {
          importe = ele.importe;
        }

        this.consumoProductos.push({
          producto_numero: ele.producto_numero,
          codigo: ele.codigo,
          producto_id: ele.producto_id,
          producto_nombre: ele.producto_nombre,
          moneda_id: ele.moneda_id,
          unidad_medida_id: ele.unidad_medida_id,
          unidad_medida_descripcion: ele.unidad_medida_descripcion,
          descripcion: ele.descripcion,
          glosa: ele.glosa,
          cantidad: ele.cantidad,
          fecha: ele.fecha,
          fecha_hora: ele.fecha_hora,
          usuario: ele.usuario,
          tipo_consumo: ele.tipo_consumo,
          estado: ele.estado,
          consumo_producto_id: ele.consumo_producto_id,
          created_at: ele.created_at ? ele.created_at : ele.fecha,
          numero: ele.numero ? ele.numero : 'Local',
          // medicamento: ele.medicamento_nombre,
          indicacion_medicamento_id: ele.indicacion_medicamento_id,
          indicacion: ele.indicacion,
          via: ele.via,
          key: ele.id ? ele.id : ele.key,
          importe: parseFloat(importe).toFixed(2),
        });
        if (ele.tipo_consumo !== 3) {
          const moneda = this.moneda.multiselect.find((mo) => mo.id === ele.moneda_id);
          if (moneda && moneda.is_principal !== 1) {
            // eslint-disable-next-line operator-assignment
            ele.producto_precio = moneda.tc * ele.producto_precio;
          }
          ele.total_venta = ele.producto_precio * ele.cantidad;
        }
        this.salidaProductos.detalles = productoObj;
      }
    },
    eliminarProducto(item) {
      if (item.consumo_producto_id > 0 && item.tipo_consumo === 3) {
        const INDEX = this.consumoProductos.findIndex((el) => el.key === item.key);
        this.consumoProductos[INDEX].estado = false;

        const INDEX_SALIDA_PRODUCTO = this.salidaProductos.detalles.findIndex((el) => el.key === item.key);
        this.salidaProductos.detalles[INDEX_SALIDA_PRODUCTO].estado = false;
        this.$refs.theModalConsumoProducto.detalles[INDEX].estado = false;
      } else {
        // nuevo
        const INDEX = this.consumoProductos.findIndex((el) => el.key === item.key);
        const INDEX_SALIDA_PRODUCTO = this.salidaProductos.detalles.findIndex((el) => el.key === item.key);
        this.consumoProductos.splice(INDEX, 1);
        this.salidaProductos.detalles.splice(INDEX_SALIDA_PRODUCTO, 1);
        this.$emit('delDetalle', INDEX);
      }
    },
    cargarConsumoProductos() {
      this.salidaProductos.salida_producto_id = this.consumoProductos[0].salida_producto_id;
      this.salidaProductos.moneda_id = this.consumoProductos[0].moneda_id;
      this.salidaProductos.cuenta_contable_id = this.consumoProductos[0].cuenta_contable_id;
      this.salidaProductos.total = parseFloat(this.consumoProductos[0]?.total) || 0;

      this.consumoProductos.forEach((ele, index) => {
        this.$set(this.consumoProductos[index], 'estado', true);
        this.$set(this.consumoProductos[index], 'key', `CP- ${ele.id}`);
        const cantidad = parseInt(ele.cantidad, 10) || 0;
        const productoPrecio = parseFloat(ele.producto_precio) || 0;
        const costoUnitario = parseFloat(ele.costo_unitario) || 0;
        const importe = (parseFloat(ele.importe)).toFixed(2) || 0;
        // Calcular total_venta y total
        const totalVenta = productoPrecio * cantidad;
        const total = cantidad * costoUnitario;
        this.salidaProductos.detalles.push({
          id: ele.id,
          salida_producto_id: ele.salida_producto_id,
          producto_id: ele.producto_id,
          consumo_producto_id: ele.consumo_producto_id,
          producto_numero: ele.producto_numero,
          codigo: ele.codigo,
          producto_nombre: ele.producto_nombre,
          producto_precio: ele.producto_precio,
          total_venta: totalVenta,
          unidad_medida_id: ele.unidad_medida_id,
          // unidad_medida_descripcion: unidad,
          descripcion: ele.descripcion,
          glosa: ele.glosa,
          cantidad: parseInt(ele.cantidad, 10),
          tc: parseFloat(ele.tc),
          lote_id: ele.lote_id,
          lote_numero: ele.lote_numero,
          costo_unitario: parseFloat(ele.costo_unitario),
          total,
          tipo_consumo: ele.tipo_consumo,
          indicacion: ele.indicacion,
          via: ele.via,
          estado: true,
          key: `CP- ${ele.id}`,
          importe,
          fecha_hora: ele.fecha_hora,
        });
      });
    },
    setTipoConsumoProducto(tipo) {
      this.tipo_consumo_producto = tipo;
    },
    addServiciosComplemetarios(dtos) {
      const SERVICIOS_COMPLEMENTARIOS = dtos;
      SERVICIOS_COMPLEMENTARIOS.forEach((element, index) => {
        const OBJ = {
          id: 0,
          servicio_complementario_id: SERVICIOS_COMPLEMENTARIOS[index].servicio_complementario_id,
          nombre: SERVICIOS_COMPLEMENTARIOS[index].nombre,
          estado: SERVICIOS_COMPLEMENTARIOS[index].estado,
          cantidad: SERVICIOS_COMPLEMENTARIOS[index].cantidad,
          precio: SERVICIOS_COMPLEMENTARIOS[index].precio,
          descripcion: SERVICIOS_COMPLEMENTARIOS[index].descripcion,
          categoria_serv_compl_id: this.categoriaServicioComplId,
          numero: SERVICIOS_COMPLEMENTARIOS[index].numero,
          categoria: SERVICIOS_COMPLEMENTARIOS[index].categoria,
          key: SERVICIOS_COMPLEMENTARIOS[index].key,
          tipo_consumo_servicio: this.tipo_consumo_producto,
          session: SERVICIOS_COMPLEMENTARIOS[index].session,
          fecha_hora: SERVICIOS_COMPLEMENTARIOS[index].fecha_hora,
        };
        this.servicioComplementario.push(OBJ);
      });
      this.filterListaTempServicioComplementario();
    },
    salidaProductosSendData() {
      this.salidaProductos.moneda_id = this.moneda.model.id;
      this.salidaProductos.cuenta_contable_id = this.dataModalCXP.parametrosContables.cuenta_debe_sp;
      let total = 0;
      for (let index = 0; index < this.salidaProductos.detalles.length;) {
        const ele = this.salidaProductos.detalles[index];
        index += 1;
        ele.fecha = (!ele.created_at) ? this.getFechaFormat(ele.fecha, 'YYYY-MM-DD HH:mm:ss') : ele.created_at;
        const eleTotal = parseFloat(ele.total) || 0;
        total += eleTotal;
        ele.total = eleTotal;
      }

      this.salidaProductos.total = total || 0; // Asegúrate de que total nunca sea null o undefined
      return this.salidaProductos;
    },

    fullformateDate(fecha) {
      const fechaFormat = this.formatearDate(fecha);
      const day = fechaFormat.getDate();
      const month = fechaFormat.getMonth();
      const year = fechaFormat.getFullYear();
      const hora = (fechaFormat.getHours() < 10) ? `0${fechaFormat.getHours()}` : fechaFormat.getHours();
      const minuto = (fechaFormat.getMinutes() < 10) ? `0${fechaFormat.getMinutes()}` : fechaFormat.getMinutes();
      return `${day}-${month}-${year} H:${hora}:${minuto}`;
    },
    async openModalPieza() {
      const params = {
        tipo_tratamiento_id: this.tipoTratamientoId,
        aseguradora_id: this.seguro.model ? this.seguro.model.id : null,
        selected_piece: null,
      };
      const RESULT_OK = await this.listSalaCama(params);
      if (RESULT_OK) {
        if (this.datoPieza) {
          this.isLoadingTratamiento = true;
          this.cargarSalaCamaID(this.datoPieza);
          this.$nextTick(() => { this.isLoadingTratamiento = false; });
        }
        this.$bvModal.show('modal-pieza');
      }
    },
    openModalAutorizacionInternacion() {
      this.medicationsProvidesByPharmacy = true;
      this.$bvModal.show('ModalAutorizacionInternacion');
    },
    openModalCierre() {
      this.$bvModal.show('modal-cierre');
    },
    manejarAutorizacion(datosAutorizacion) {
      // Recibir los datos del modal de autorización
      this.confirmacioAutorizacion = datosAutorizacion.confirmacion_autorizacion;
      this.autorizacionData = { ...datosAutorizacion.autorizacion };

      // Cerrar el modal
      this.$bvModal.hide('ModalAutorizacionInternacion');
    },
    cargarDatosAutorizacion(dataTratamientos, autorizacionBackend) {
      // Cargar confirmacion_autorizacion desde data_tratamientos
      this.confirmacioAutorizacion = dataTratamientos.confirmacion_autorizacion === 1;

      // Establecer estado del botón de medicamentos
      if (this.confirmacioAutorizacion) {
        this.medicationsProvidesByPharmacy = true;
      }

      // Cargar datos de autorización si existen
      if (autorizacionBackend && autorizacionBackend !== null) {
        this.autorizacionData = {
          id: autorizacionBackend.id || 0, // ID real para edición, 0 para nuevo
          nombre: autorizacionBackend.nombre || '',
          ci: autorizacionBackend.ci || '',
          parentesco: autorizacionBackend.parentesco || '',
          is_manual: autorizacionBackend.is_manual === 1 || autorizacionBackend.is_manual === true,
        };
      } else {
        // Si no hay autorización existente, asegurar que ID sea 0
        this.autorizacionData.id = 0;
      }
    },
    ...mapMutations('modalPieza', [
      'cargarSalaEdit',
      'cargarSalaCamaID',
    ]),
    ...mapActions('modalPieza', [
      'resetModalPieza',
      'listSalaCama',
    ]),
    ...mapActions('modalHojaAdmision', [
      'resetModalHojaAdminision',
    ]),
    eliminarServiciosInternos(item) {
      const NRO = item.numero;
      if (NRO === '-') {
        const INDEX = this.servicios.findIndex((el) => el.customId === item.customId);
        this.servicios.splice(INDEX, 1);
      } else {
        const INDEX = this.servicios.findIndex((el) => el.customId === item.customId);
        this.servicios[INDEX].venta_servicio_estado = false;
      }
    },
    addServiciosInternos(data) {
      const service = data.servicios;
      this.servicios.push(service);
      // this.$refs.theModalPreCierre.restaurar();
    },
    setServicesData() {
      this.servicios.forEach((item) => {
        this.$set(item, 'venta_servicio_estado', true);
        this.$set(item, 'customId', item.id);
        const glosa = JSON.parse(item.glosas);
        // eslint-disable-next-line no-param-reassign
        item.glosas = glosa;
        // this.serviciosAllInternos.forEach((ele) => {
        //   if (item.tipo_servicio_id === null) {
        //     if (item.honorario_medico_id === ele.id) {
        //       this.$set(item, 'tipo_servicio_nombre', ele.tipo_servicio_nombre);
        //     }
        //   } else if (item.tipo_servicio_id === ele.id) {
        //     this.$set(item, 'tipo_servicio_nombre', ele.tipo_servicio_nombre);
        //   }
        // });
      });
      // this.agregarCategoriaServicios();
      this.convertirAcadenaGlosa();
    },
    convertirAcadenaGlosa() {
      let TEXTOGLOSA = '';
      this.servicios.forEach((ele) => {
        ele.glosas.forEach((item, index) => {
          if (item.nombre != null) {
            if (index === 0) {
              TEXTOGLOSA = item.nombre;
              this.$set(ele, 'textoglosa', TEXTOGLOSA);
            } else {
              TEXTOGLOSA = item.nombre;
              // eslint-disable-next-line no-param-reassign
              ele.textoglosa = `${ele.textoglosa} , ${TEXTOGLOSA}`;
            }
          }
        });
      });
    },
    showModalServicioInterno(dataServicio) {
      const DATA = this.cloneObject(dataServicio);
      this.$refs.servicioInterno.showModalEventEdit(DATA);
    },
    agregarPrecierre(data) {
      this.preCierreData.total_precierre = data.total;
      this.preCierreData.saldo_precierre = data.saldo;
      this.preCierreData.anticipo_precierre = data.anticipo;
      this.preCierreData.glosa_precierre = data.glosa;
      this.preCierreData.estado_precierre = data.estado_pre_cierre;
      this.preCierreData.custom_id = data.custom_id;
      this.preCierreData.hora = data.hora;
      this.preCierreData.fecha = data.fecha;
      this.preCierreData.usuario = data.usuario;
      this.preCierre = data.isPrecierre;
      if (!this.preCierreData.first_precierre_tratamiento_edit
        || this.preCierreData.first_precierre_tratamiento_edit === 0
      ) {
        this.preCierreData.first_fecha_precierre = moment().format();
        this.preCierreData.first_precierre_tratamiento = true;
        // this.this.preCierreData.first_precierre_tratamiento_edit = true;
      }
    },
    agregarCategoriaServicios() {
      this.servicios.forEach((item, index) => {
        this.categoriaServiciosInternos.forEach((ele) => {
          if (item.categoria_medico_id === ele.id) {
            let nombreServicio = item.tipo_servicio_nombre;
            nombreServicio = `${nombreServicio} - ${ele.nombre}`;
            // eslint-disable-next-line no-param-reassign
            this.servicios[index].tipo_servicio_nombre = nombreServicio;
          }
        });
      });
    },
    cargarModalPreCierre(data) {
      if (data.precierre) {
        // true tiene un precierre y esta activo
        this.preCierreData.id = data.id;
        this.preCierreData.total_precierre = data.total;
        this.preCierreData.anticipo_precierre = data.anticipo;
        this.preCierreData.saldo_precierre = data.saldo;
        this.preCierreData.glosa_precierre = data.glosa;
        this.preCierreData.estado_precierre = data.precierre;
        this.preCierreData.fecha = data.fecha;
        this.preCierreData.hora = data.hora;
        this.preCierre = data.precierre !== 0;
        this.preCierreData.usuario = data.usuario;
        this.preCierreData.first_fecha_precierre = data.first_fecha_precierre;
        this.preCierreData.first_precierre_tratamiento = data.first_precierre_tratamiento;
        this.preCierreData.first_precierre_tratamiento_edit = data.first_precierre_tratamiento;
      } else {
        // tiene precierre pero esta desabiitado
        this.preCierreData.id = data.id;
        this.preCierreData.total_precierre = 0;
        this.preCierreData.anticipo_precierre = (this.dataPaciente.anticipo)
          ? this.dataPaciente.anticipo : 0;
        this.preCierreData.saldo_precierre = 0;
        // this.preCierreData.glosa_precierre = data.glosa;
        this.preCierreData.estado_precierre = data.precierre;
        this.preCierre = data.precierre !== 0;
        this.preCierreData.usuario = data.usuario;
        this.preCierreData.first_fecha_precierre = data.first_fecha_precierre;
        this.preCierreData.first_precierre_tratamiento = data.first_precierre_tratamiento;
        this.preCierreData.first_precierre_tratamiento_edit = data.first_precierre_tratamiento;
      }
    },
    cargarDatosPreCierre() {
      const TOTAL = parseFloat(this.serviciosInternos) + parseFloat(this.centasXPagar)
      + parseFloat(this.consumoProducto) + parseFloat(this.totalServicioComplementarios)
      + parseFloat(this.totalImporteSalaCama);
      const SALDO = parseFloat(TOTAL) - parseFloat(this.preCierreData.anticipo_precierre);
      this.preCierreData.total_precierre = TOTAL;
      this.preCierreData.saldo_precierre = SALDO;
    },
    limpiarPreCierre() {
      this.preCierreData.total_precierre = 0;
      // this.preCierreData.anticipo_precierre = 0;
      this.preCierreData.saldo_precierre = 0;
      this.preCierreData.glosa_precierre = null;
      this.preCierreData.estado_precierre = false;
      this.preCierreData.custom_id = new Date().getTime();
      if (!this.preCierreData.first_precierre_tratamiento_edit) {
        this.preCierreData.first_precierre_tratamiento = false;
        this.preCierreData.first_fecha_precierre = null;
      }
      // marcar el estado del cierre como false;
      this.cierre.estado = false;
      this.cierre.hora = null;
      this.cierre.glosa = null;
    },
    agregarCierre(data) {
      this.cierre.fecha = data.fecha;
      this.cierre.hora = data.hora;
      this.cierre.glosa = data.glosa;
      this.cierre.estado = data.estado;
    },
    activateTheButton(data) {
      this.nombreButtonActivo = data;
      this.categoriaServicioComplId = null;
      this.$bvModal.hide('theModalProductoServicios');
      this.$bvModal.hide('TheModalFisioterapia');
    },
    async openModalServicios(titleModal, catServicioCompId) {
      this.descripcionTitulo = titleModal;
      this.nombreButtonActivo = titleModal;
      this.categoriaServicioComplId = catServicioCompId;
      await this.resetDataTheModaServios();
      const DTO = {
        catServicioCompId,
        seguro: this.seguro.model,
        origen: MODULOS.INTERNACION,
      };
      await this.getDataServicioComplementario(DTO);
      // ocultar el modal consumoProducto o Farmacia
      this.$refs.theModalConsumoProducto.onCloseModal();
      this.$bvModal.show('theModalProductoServicios');
    },
    async openModalFisioterapia(titleModal, categoriaId) {
      this.descripcionTitulo = titleModal;
      this.nombreButtonActivo = titleModal;
      this.categoriaServicioComplId = categoriaId;
      await this.resetDataTheModaServios();
      const DTO = {
        catServicioCompId: categoriaId,
        seguro: this.seguro.model,
        origen: MODULOS.INTERNACION,
      };
      await this.getDataServicioComplementario(DTO);
      // ocultar el modal consumoProducto o Farmacia
      this.$refs.theModalConsumoProducto.onCloseModal();
      this.$bvModal.show('TheModalFisioterapia');
    },
    onClickButtonEvolucionMedica() {
      this.nombreButtonActivo = 'evolucion_medica';
      this.categoriaServicioComplId = null;
      this.$bvModal.hide('theModalProductoServicios');
      this.$bvModal.hide('TheModalFisioterapia');
      this.openModalEvolucionMedica();
    },
    openModalEvolucionMedica() {
      this.$bvModal.show('TheModalEvolucionMedica');
    },
    openModalCirugia(toAddNewItem) {
      this.modeAddItem = toAddNewItem;
      this.$bvModal.show('modal-cirugia');
    },
    openModalInterConsulta() {
      this.setDataInicialInterConsulta();
      this.setDataInicialRespuesta();
      this.$bvModal.show('modal-interConsulta');
    },
    addItemCirugia(data) {
      const item = {
        id: data.id,
        modeAddCirugia: false,
      };
      this.cirugias.push(item);
    },
    saveData() {
      //
    },
    eliminarServicio(item) {
      const ID = item.id;
      if (ID > 0) {
        const INDEX = this.servicioComplementario.findIndex((el) => (
          el.id === item.id));
        this.servicioComplementario[INDEX].estado = false;
      } else {
        const INDEX = this.servicioComplementario.findIndex((el) => (
          el.key === item.key));
        this.servicioComplementario.splice(INDEX, 1);
      }
      this.filterListaTempServicioComplementario();
    },
    filterListaTempServicioComplementario() {
      switch (this.categoriaServicioComplId) {
        case this.categoriaLaboratorio:
          this.listTempServiciosComplementarios = this.servicioComplementario.filter((obj) => (
            obj.categoria_serv_compl_id === this.categoriaLaboratorio && obj.estado === true
          ));
          break;
        case this.categoriaEcografia:
          this.listTempServiciosComplementarios = this.servicioComplementario.filter((obj) => (
            obj.categoria_serv_compl_id === this.categoriaEcografia && obj.estado === true
          ));
          break;
        case this.categoriaRayosX:
          this.listTempServiciosComplementarios = this.servicioComplementario.filter((obj) => (
            obj.categoria_serv_compl_id === this.categoriaRayosX && obj.estado === true
          ));
          break;
        case this.categoriaTomografia:
          this.listTempServiciosComplementarios = this.servicioComplementario.filter((obj) => (
            obj.categoria_serv_compl_id === this.categoriaTomografia && obj.estado === true
          ));
          break;
        case this.categoriaMamografia:
          this.listTempServiciosComplementarios = this.servicioComplementario.filter((obj) => (
            obj.categoria_serv_compl_id === this.categoriaMamografia && obj.estado === true
          ));
          break;
        case this.categoriaArcoC:
          this.listTempServiciosComplementarios = this.servicioComplementario.filter((obj) => (
            obj.categoria_serv_compl_id === this.categoriaArcoC && obj.estado === true
          ));
          break;
        case this.categoriaFisioterapia:
          this.listTempServiciosComplementarios = this.servicioComplementario.filter((obj) => (
            obj.categoria_serv_compl_id === this.categoriaFisioterapia && obj.estado === true
          ));
          break;
        case this.categoriaTratam:
          this.listTempServiciosComplementarios = this.servicioComplementario.filter((obj) => (
            obj.categoria_serv_compl_id === this.categoriaTratam && obj.estado === true
          ));
          break;

        default:
          break;
      }
    },
    goToHistorialClinico() {
      const paciente = this.pacienteSelected;
      if (paciente) {
        this.guardarDatosTemporal();
        this.activeHC = true;
      } else {
        util.showNotify('Debe Seleccionar un Paciente', 'warn');
      }
    },
    manejarHistorialClinico(localHistorialClinico, localActiveHC, dataPaciente) {
      if (localHistorialClinico.length !== 0 && this.historialClinico !== 0) {
        this.historialClinico[0] = localHistorialClinico;
      } else {
        this.historialClinico = localHistorialClinico;
      }
      this.activeHC = localActiveHC;
      this.dataPaciente = { ...dataPaciente };
    },
    verificarHistorialClinico(obj) {
      const camposExcluidos = ['id', 'fecha', 'hora'];

      const esVacio = (value) => value === '' || value === null || value === 0 || value === 'Invalid date';
      const verificarObjeto = (objeto) => Object.entries(objeto).every(([key, value]) => {
        if (camposExcluidos.includes(key)) {
          return true;
        }

        if (typeof value === 'object' && value !== null) {
          return verificarObjeto(value);
        }
        return esVacio(value);
      });
      return verificarObjeto(obj);
    },
    guardarDatosTemporal() {
      this.pacienteTemporal = this.pacienteSelected;
      this.seguroTemporal = this.seguro;
    },
    addEvolucionMedica(dto) {
      const OBJECT = {
        id: dto.id,
        descripcion_medico: dto.descripcion,
        indicacion_medico: dto.indicacion,
        medico: dto.userName,
        estado: dto.estado,
        fecha: dto.fecha,
        hora: dto.hora,
      };
      this.evolucionMedicas.push(OBJECT);
    },
    eliminarEvolucionMedica(item) {
      const ID = item.id;
      if (ID > 0) {
        const INDEX = this.evolucionMedicas.findIndex((el) => (
          el.id === item.id));
        this.evolucionMedicas[INDEX].estado = false;
      } else {
        const INDEX = this.evolucionMedicas.findIndex((el) => (
          el.key === item.key));
        this.evolucionMedicas.splice(INDEX, 1);
      }
    },
    formattedDate(fecha) {
      const date = new Date(fecha);
      return date.toLocaleDateString('es-ES', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
      });
    },

    guardarDiagnosticoSeleccionado(diagnostico) {
      if (diagnostico) {
        this.diagnosticoSeleccionado = diagnostico;
      } else {
        this.diagnosticoSeleccionado = null;
      }
    },
    async selectItem(item) {
      const origen = null;
      if (item.id !== 0) {
        const RESULT_OK = await this.getIndicacionMedica({ id: item.id, origen });
        if (RESULT_OK) {
          this.$bvModal.show('modal-indicacionMedica');
        }
      }
    },
    async printReceta(item) {
      console.log('item', item);
      const EVOLUCION_ID = item.id;
      const params = {
        tratamiento_id: this.id,
      };
      try {
        const RESPONSE = await axios.get(
          `clinic/tratamiento/print_receta_evolucion_medica/${EVOLUCION_ID}`,
          {
            responseType: 'blob',
            params,
          },
        );
        console.log('error', RESPONSE);
        const BLOB = new Blob([RESPONSE.data], { type: 'application/pdf' });
        const DOWNLOAD_URL = URL.createObjectURL(BLOB);
        window.open(DOWNLOAD_URL, '_blank');
      } catch (error) {
        util.showNotify(error.response.data.message, 'error');
      }
    },
    manejarFamiliarSeleccionado(data) {
      // verificar si es contacto o familiar
      if (data.tipo_familiar === TIPO_BUTTON_ADMISION.CONTACTO) {
        // contacto
        this.contactoPacienteId = data.data_familiar.id;
        this.familiar_id = null;
      } else {
        this.familiar_id = data.data_familiar.id;
        this.contactoPacienteId = null;
      }
    },
    ...mapActions('theModalMedicalIndication', [
      'resetTheModalIndicacionMedica',
      'getIndicacionMedica',
    ]),
    openModalSignosVitales() {
      this.$bvModal.show('modal-signo-vitales');
    },
    addSignosVitales(data) {
      this.signosVitales = [];
      const obj = {
        id: data.id,
        talla: data.talla,
        peso: data.peso,
        temperatura: data.oral,
        indice_masa_corporal: data.indiceCorporal,
        pulso: null,
        frecuencia_respiratoria: data.frecuenciaRespiratoria,
        frecuencia_cardiaca: data.frecuenciaCardiaca,
        saturacion_oxigeno: data.saturacionOxigeno,
        presion_arterial_sistolica: data.sistolica,
        presion_arterial_diastolica: data.diastolica,
        estado: true,
      };
      this.signosVitales.push(obj);
    },
    ...mapMutations('theModalSignosVitales', [
      'cargarDataSignoVitales',
    ]),
    ...mapActions('theDiagnostic', [
      'resetTheDiagnosticData',
    ]),
    ...mapMutations('theModalInterConsulta', [
      'setDataInicialSolicitud',
      'setTabRespuesta',
      'setItemTabSolicitud',
    ]),
    ...mapActions('theModalInterConsulta', [
      'resetTheModalInterConsulta',
    ]),
    setInterConsulta(item, index) {
      const SOLICITANTE_SELECTED = this.medico.listaMedicos.find((el) => (
        el.id === item.solicitante_medico_id
      ));
      const DESTINATARIO_SELECTED = this.medico.listaMedicos.find((el) => (
        el.id === item.destinatario_medico_id
      ));
      const DATA = {
        solicitanteSelected: SOLICITANTE_SELECTED,
        fecha: item.fecha,
        destinatarioSelected: DESTINATARIO_SELECTED,
        hora: item.hora,
        valoracion: item.valoracion,
        resumeClinico: item.resumen_clinico,
        atencionesRealizadas: item.atenciones_realizadas,
        evolucionPaciente: item.evolucion_paciente,
        motivo: item.motivo,
        respuesta: item.respuesta,
        interconsulta_id: item.interconsulta_id,
        listaSolicitantes: this.medico.listaMedicos,
        listaDestinatarios: this.medico.listaDestinatarios,
        numero: item.numero,
        isEdit: true,
        index,
      };
      this.setItemTabSolicitud(DATA);

      const RESPUESTA_INTERCONSULTA = {
        respuesta_id: DATA.respuesta
          ? DATA.respuesta.respuesta_id : null,
        fecha: DATA.respuesta
          ? new Date(moment(DATA.respuesta.fecha)) : new Date(),
        hora: DATA.respuesta
          ? DATA.respuesta.hora : moment().format('HH:mm:ss'),
        informe: DATA.respuesta
          ? DATA.respuesta.informe : null,
        recomendacion: DATA.respuesta
          ? DATA.respuesta.recomendacion : null,
        solicitanteSelected: SOLICITANTE_SELECTED,
        listaSolicitantes: this.medico.listaMedicos,
        destinatarioSelected: DESTINATARIO_SELECTED,
        listaDestinatarios: this.medico.listaMedicos,
      };
      this.setTabRespuesta(RESPUESTA_INTERCONSULTA);
      this.$bvModal.show('modal-interConsulta');
    },
    setDataInicialInterConsulta() {
      let medicoSolicitante = null;
      if (this.medicoInterConsulta) {
        medicoSolicitante = this.medico.listaMedicos.find((m) => m.id === this.medicoInterConsulta.id);
      }
      const SOLICITUD_INTERCONSULTA = {
        solicitanteSelected: medicoSolicitante,
        listaSolicitantes: this.medico.listaMedicos,
        destinatarioSelected: null,
        listaDestinatarios: this.medico.listaMedicos,
        fecha: new Date(),
        hora: moment().format('HH:mm:ss'),
        valoracion: null,
        resumeClinico: null,
        atencionesRealizadas: null,
        evolucionPaciente: null,
        motivo: null,
        respuesta: null,
        interconsulta_id: null,
        numero: this.interConsultas.length + 1,
        isEdit: false,
        index: null,
      };
      const RESPUESTA_INTERCONSULTA = {
        solicitanteSelected: null,
        listaSolicitantes: this.medico.listaMedicos,
        fecha: new Date(),
        destinatarioSelected: null,
        listaDestinatarios: this.medico.listaMedicos,
        hora: moment().format('HH:mm:ss'),
        respuesta_id: null,
        recomendacion: null,
        informe: null,
      };

      this.setDataInicialSolicitud(SOLICITUD_INTERCONSULTA);
      this.setTabRespuesta(RESPUESTA_INTERCONSULTA);
    },
    setDataInicialRespuesta() {
      const RESPUESTA_INTERCONSULTA = {
        respuesta_id: null,
        fecha: new Date(),
        hora: moment().format('HH:mm:ss'),
        informe: null,
        recomendacion: null,
        solicitanteSelected: null,
        listaSolicitantes: this.medico.listaMedicos,
        destinatarioSelected: null,
        listaDestinatarios: this.medico.listaMedicos,
      };
      this.setTabRespuesta(RESPUESTA_INTERCONSULTA);
    },
    setEditInterConsulta(interconsultas) {
      interconsultas.forEach((el, index) => {
        const MEDICO_SOLICITANTE = this.medico.listaMedicos.find((m) => m.id === el.medico_solicitante_id);
        const MEDICO_DESTINARIO = this.medico.listaMedicos.find((m) => m.id === el.medico_destinatario_id);
        let respuestaSolicitud = null;
        if (el.respuesta) {
          respuestaSolicitud = {
            respuesta_id: el.respuesta ? el.respuesta.id : null,
            fecha: el.respuesta ? el.respuesta.fecha : null,
            hora: el.respuesta ? el.respuesta.hora : null,
            informe: el.respuesta ? el.respuesta.informe : null,
            recomendacion: el.respuesta ? el.respuesta.recomendacion : null,
            solicitanteSelected: MEDICO_SOLICITANTE,
            listaSolicitantes: this.medico.listaMedicos,
            destinatarioSelected: MEDICO_DESTINARIO,
            listaDestinatarios: this.medico.listaMedicos,
          };
        }
        let valoracion = null;
        switch (el.estado_salud) {
          case 'Bueno':
            valoracion = '1';
            break;
          case 'Malo':
            valoracion = '2';
            break;
          case 'Regular':
            valoracion = '3';
            break;
          default:
            break;
        }
        const obj = {
          interconsulta_id: el.interconsulta_id,
          numero: el.numero,
          fecha: el.fecha,
          hora: el.hora,
          estado_salud: el.estado_salud,
          resumen_clinico: el.resumen_clinico,
          atenciones_realizadas: el.atenciones_realizadas,
          evolucion_paciente: el.evolucion_paciente,
          motivo: el.motivo,
          solicitante_medico_id: el.medico_solicitante_id,
          destinatario_medico_id: el.medico_destinatario_id,
          respuesta: respuestaSolicitud,
          isEdit: true,
          index,
          listaSolicitantes: this.medico.listaMedicos,
          solicitanteSelected: MEDICO_SOLICITANTE,
          destinatarioSelected: MEDICO_DESTINARIO,
          listaDestinatarios: this.medico.listaMedicos,
          valoracion,

        };
        this.interConsultas.push(obj);
      });
    },
    clearInterConsultas() {
      this.interConsultas.forEach((e, index) => {
        delete this.interConsultas[index].listaSolicitantes;
        delete this.interConsultas[index].solicitanteSelected;
        delete this.interConsultas[index].destinatarioSelected;
        delete this.interConsultas[index].listaDestinatarios;
      });
      return this.interConsultas;
    },
    async getTipoSeguro() {
      if (!this.dataPaciente.id) {
        util.showNotify('Debe Seleccionar un paciente', 'error');
        return;
      }
      if (this.seguro.model) {
        const params = {
          aseguradora_id: this.seguro.model.id,
          tipo_seguro_id: 2,
        };
        axios.get('/clinic/insurer/load/currency_limit', { params })
          .then((response) => {
            this.tipoSeguroSeleccionado = parseInt(response.data.data.limite_monetario, 10);
            this.verificarTotal();
          })
          .catch((error) => {
            util.showNotify(error.response.data.message, 'error');
          });
      }
    },
    calcular() {
      if (!this.dataPaciente.id) {
        util.showNotify('Debe Seleccionar un paciente', 'error');
        return;
      }

      if (!Array.isArray(this.servicioComplementario)) {
        util.showNotify('Los servicios complementarios no están cargados', 'error');
        return;
      }

      let TOTAL = 0;
      this.servicioComplementario.forEach((item) => {
        if (item.precio) {
          TOTAL += parseFloat(item.precio || 0);
        }
      });

      TOTAL += this.serviciosInternos;

      this.consumoProductos.forEach((item) => {
        if (item.tipo_consumo === 2) {
          // ventas
          TOTAL += parseFloat(item.importe || 0);
        }
      });
      if (this.getImporteXDiaSalaCama !== 0) {
        TOTAL += parseInt(this.totalImporteSalaCama, 10);
      }
      TOTAL += this.centasXPagar;
      this.total = TOTAL;
    },
    verificarTotal() {
      if (this.total > this.tipoSeguroSeleccionado && this.tipoSeguroSeleccionado > 0) {
        this.mostrarModal = true;
      }
    },
    aceptarModal() {
      this.mostrarModal = false;
      this.modalPermanenteCerrado = true;
    },
    cerrarModal() {
      this.mostrarModal = false;
    },
    formattedDateAntecedent(fecha) {
      if (!fecha) return null;

      const dateObj = new Date(fecha);

      // eslint-disable-next-line no-restricted-globals
      if (isNaN(dateObj.getTime())) return null; // Validar que la fecha sea válida

      const year = dateObj.getFullYear();
      const month = String(dateObj.getMonth() + 1).padStart(2, '0'); // +1 porque los meses van de 0 a 11
      const day = String(dateObj.getDate()).padStart(2, '0');

      return `${year}-${month}-${day}`; // Formato "YYYY-MM-DD"
    },
    openModalAntecedentes() {
      this.$bvModal.show('theModalAntecedente');
    },
    addAntecedentes(data) {
      this.listaAntecedentes = data;
      this.hasValidAntecedentes();
    },
    hasValidAntecedentes() {
      return Object.keys(this.listaAntecedentes).some((key) => {
        if (key === 'fechaInicio' || key === 'fechaInicio2' || key === 'id') {
          return false;
        }

        const value = this.listaAntecedentes[key];
        if (!value || (Array.isArray(value) && value.length === 0)) {
          return false;
        }

        return true;
      });
    },
    rejectAutorizacion() {
      this.medicationsProvidesByPharmacy = false;
      this.confirmacioAutorizacion = false;
      this.autorizacionData = null;
    },
    async openModalDescuentos() {
      if (this.getIDItemChecked) {
        try {
          const response = await axios.post(
            `clinic/tratamientos/store/detalle_dia_sala_cama/${this.id}`,
            { sala_cama_id: this.getIDItemChecked },
          );
          this.diasCargadosSalaCama = response.data.data.data || [];
        } catch (error) {
          util.showNotify(error?.response?.data?.message ?? 'Error al cargar días', 'error');
        }
      }
      this.$refs.modalDescuentos.abrir({
        tratamientoId: this.id,
        descuentoGeneral: this.descuento_gral,
        descuentoMonto: this.descuento_monto,
        aplicarDescuentoGeneral: this.descuento_gral === 1,
        noFigurarDescuento: this.no_aplicar_en_venta === 1,
        camasDias: this.camasDiasGuardados,
        diasCargados: this.diasCargadosSalaCama,
      });
    },
    onGuardarDescuentos(data) {
      this.camasDiasGuardados = data.camasDias;
      const camasDias = data.camasDias || {};
      const nuevaDetalle = [];
      Object.keys(camasDias).forEach((key) => {
        camasDias[key].forEach((dia) => {
          if (dia.id) {
            nuevaDetalle.push({ id: dia.id, estado: !dia.anulado });
          }
        });
      });
      if (nuevaDetalle.length > 0) {
        this.detalle_sala_camas = nuevaDetalle;
        axios.post(
          `clinic/tratamientos/store/detalle_dia_sala_cama/${this.id}`,
          { sala_cama_id: this.getIDItemChecked },
        ).then((response) => {
          this.diasCargadosSalaCama = response.data.data.data || [];
        }).catch((error) => {
          util.showNotify(error?.response?.data?.message ?? 'Error al guardar días de cama', 'error');
        });
      }
      this.descuento_gral = data.aplicarDescuentoGeneral ? 1 : 0;
      this.no_aplicar_en_venta = data.noFigurarDescuento ? 1 : 0;
      if (data.aplicarDescuentoGeneral) {
        this.descuento_monto = data.descuentoGeneral;
      } else if (data.descuentoItemsChanged) {
        this.descuento_monto = data.items.reduce(
          (acc, item) => acc + (parseFloat(item.descuento) || 0), 0,
        );
      }
      const activosServs = this.servicioComplementario.filter((sc) => sc.estado);
      data.items.forEach((item, idx) => {
        if (activosServs[idx]) {
          this.$set(activosServs[idx], 'descuento_unitario', item.descuento);
        }
      });
    },
  },
  computed: {
    ...mapGetters('modalPieza', [
      'getIDItemChecked',
      'getCamaItemChecked',
      'getPisoSalaItemChecked',
      'getImporteXDiaSalaCama',
    ]),
    ...mapGetters('main', [
      'isBloqueoDescuentoInternacion',
    ]),
    categoriaEcografia() {
      return CATEGORIA_SERVICIO_COMPL.ECOGRAFIA;
    },
    categoriaLaboratorio() {
      return CATEGORIA_SERVICIO_COMPL.LABORATORIO;
    },
    categoriaRayosX() {
      return CATEGORIA_SERVICIO_COMPL.RAYOS_X;
    },
    categoriaTomografia() {
      return CATEGORIA_SERVICIO_COMPL.TOMOGRAFIA;
    },
    categoriaMamografia() {
      return CATEGORIA_SERVICIO_COMPL.MAMOGRAFIA;
    },
    categoriaArcoC() {
      return CATEGORIA_SERVICIO_COMPL.ARCO_C;
    },
    categoriaFisioterapia() {
      return CATEGORIA_SERVICIO_COMPL.FISIOTERAPIA;
    },
    categoriaFarmacia() {
      return CATEGORIA_SERVICIO_COMPL.FARMACIA;
    },
    categoriaTratam() {
      return CATEGORIA_SERVICIO_COMPL.TRATAMIENTO;
    },
    isDisabledAlmacen() {
      return this.salidaProductos.detalles.length > 0;
    },
    getClassButtonFarmacia() {
      let classToApply = 'btn-light';
      /* if (this.consulta === null) {
        return classToApply;
      } */
      if (this.nombreButtonActivo === this.getNameFarmacia) {
        classToApply = 'btn-success';
      } else {
        classToApply = 'btn-secondary';
      }
      return classToApply;
    },
    getClassButtonLaboratorio() {
      let classToApply = 'btn-secondary';
      if (this.nombreButtonActivo === this.getNameLaboratorio) {
        classToApply = 'btn-success';
      }
      return classToApply;
    },
    getClassButtonEcografia() {
      let classToApply = 'btn-secondary';
      if (this.nombreButtonActivo === this.getNameEcografia) {
        classToApply = 'btn-success';
      }
      return classToApply;
    },
    getClassButtonRayosX() {
      let classToApply = 'btn-secondary';
      if (this.nombreButtonActivo === this.getNameRayosX) {
        classToApply = 'btn-success';
      }
      return classToApply;
    },
    getClassButtonTomografia() {
      let classToApply = 'btn-secondary';
      if (this.nombreButtonActivo === this.getNameTomografia) {
        classToApply = 'btn-success';
      }
      return classToApply;
    },
    getClassButtonMamografia() {
      let classToApply = 'btn-secondary';
      if (this.nombreButtonActivo === this.getNameMamografia) {
        classToApply = 'btn-success';
      }
      return classToApply;
    },
    getClassButtonArcoC() {
      let classToApply = 'btn-secondary';
      if (this.nombreButtonActivo === this.getNameArcoEnC) {
        classToApply = 'btn-success';
      }
      return classToApply;
    },
    getClassButtonFisioterapia() {
      let classToApply = 'btn-secondary';
      if (this.nombreButtonActivo === this.getNameFisioterapia) {
        classToApply = 'btn-success';
      }
      return classToApply;
    },
    getClassButtonTratamiento() {
      let classToApply = 'btn-secondary';
      if (this.nombreButtonActivo === this.getNameTratamiento) {
        classToApply = 'btn-success';
      }
      return classToApply;
    },
    serviciosFiltered() {
      return this.servicios.filter((item) => item.venta_servicio_estado === true);
    },
    serviciosInternos() {
      let total = 0;
      this.serviciosFiltered.forEach((item) => {
        total += parseFloat(item.importe);
      });
      return total;
    },
    centasXPagar() {
      let total = 0;
      this.cuentas_x_pagar.forEach((item) => {
        const tipoMoneda = this.moneda.multiselect.find(
          (el) => el.id === item.moneda_id,
        );
        if (tipoMoneda.is_principal === 0) {
          total += parseFloat(item.importe) * parseFloat(tipoMoneda.tc);
        } else {
          total += parseFloat(item.importe);
        }
      });
      return total;
    },
    consumoProducto() {
      let total = 0;
      this.salidaProductos.detalles.forEach((item) => {
        if (item.tipo_consumo === 2 && item.estado) {
          total += parseFloat(item.total_venta);
        }
      });
      return total;
    },
    getNameFarmacia() {
      if (this.getItemFarmacia != null) {
        return this.getItemFarmacia.nombre;
      }
      return 'Farmacia';
    },
    getNameLaboratorio() {
      if (this.getItemLaboratorio != null) {
        return this.getItemLaboratorio.nombre;
      }
      return 'Laboratorio';
    },
    getNameEcografia() {
      if (this.getItemEcografia != null) {
        return this.getItemEcografia.nombre;
      }
      return 'Ecografia';
    },
    getNameRayosX() {
      if (this.getItemRayosX != null) {
        return this.getItemRayosX.nombre;
      }
      return 'Rayos X';
    },
    getNameTomografia() {
      if (this.getItemTomografia != null) {
        return this.getItemTomografia.nombre;
      }
      return 'Tomografia';
    },
    getNameMamografia() {
      if (this.getItemMamografia != null) {
        return this.getItemMamografia.nombre;
      }
      return 'Mamografia';
    },
    getNameArcoEnC() {
      if (this.getItemArcoC != null) {
        return this.getItemArcoC.nombre;
      }
      return 'Arco en C';
    },
    getNameFisioterapia() {
      if (this.getItemFisioterapia != null) {
        return this.getItemFisioterapia.nombre;
      }
      return 'Fisioterapia';
    },
    getNameTratamiento() {
      if (this.getItemTratamiento != null) {
        return this.getItemTratamiento.nombre;
      }
      return 'Tratamiento';
    },
    getItemFarmacia() {
      if (this.parametroServicioComplementarioList.length > 0) {
        const item = this.parametroServicioComplementarioList.find((el) => el.servicio_complementario_categoria_id === 8) ?? null;
        return item;
      }
      return null;
    },
    getItemLaboratorio() {
      if (this.parametroServicioComplementarioList.length > 0) {
        const item = this.parametroServicioComplementarioList.find((el) => el.servicio_complementario_categoria_id === 9) ?? null;
        return item;
      }
      return null;
    },
    getItemEcografia() {
      if (this.parametroServicioComplementarioList.length > 0) {
        const item = this.parametroServicioComplementarioList.find((el) => el.servicio_complementario_categoria_id === 1) ?? null;
        return item;
      }
      return null;
    },
    getItemRayosX() {
      if (this.parametroServicioComplementarioList.length > 0) {
        const item = this.parametroServicioComplementarioList.find((el) => el.servicio_complementario_categoria_id === 2) ?? null;
        return item;
      }
      return null;
    },
    getItemTomografia() {
      if (this.parametroServicioComplementarioList.length > 0) {
        const item = this.parametroServicioComplementarioList.find((el) => el.servicio_complementario_categoria_id === 3) ?? null;
        return item;
      }
      return null;
    },
    getItemMamografia() {
      if (this.parametroServicioComplementarioList.length > 0) {
        const item = this.parametroServicioComplementarioList.find((el) => el.servicio_complementario_categoria_id === 4) ?? null;
        return item;
      }
      return null;
    },
    getItemArcoC() {
      if (this.parametroServicioComplementarioList.length > 0) {
        const item = this.parametroServicioComplementarioList.find((el) => el.servicio_complementario_categoria_id === 5) ?? null;
        return item;
      }
      return null;
    },
    getItemFisioterapia() {
      if (this.parametroServicioComplementarioList.length > 0) {
        const item = this.parametroServicioComplementarioList.find((el) => (
          el.servicio_complementario_categoria_id === CATEGORIA_SERVICIO_COMPL.FISIOTERAPIA))
          ?? null;
        return item;
      }
      return null;
    },
    getItemTratamiento() {
      if (this.parametroServicioComplementarioList.length > 0) {
        const item = this.parametroServicioComplementarioList.find((el) => (
          el.servicio_complementario_categoria_id === CATEGORIA_SERVICIO_COMPL.TRATAMIENTO))
          ?? null;
        return item;
      }
      return null;
    },
    isActiveFarmacia() {
      if (this.getItemFarmacia != null) {
        return this.getItemFarmacia.estado;
      }
      return false;
    },
    tieneDiasAnulados() {
      if (this.detalle_sala_camas.some((d) => d.estado === false || d.estado === 0)) {
        return true;
      }
      if (this.diasCargadosSalaCama.some((d) => d.estado === false || d.estado === 0)) {
        return true;
      }
      return Object.values(this.camasDiasGuardados).some(
        (dias) => dias.some((d) => d.anulado),
      );
    },
    isActiveLaboratorio() {
      if (this.getItemLaboratorio != null) {
        return this.getItemLaboratorio.estado;
      }
      return false;
    },
    isActiveEcografia() {
      if (this.getItemEcografia != null) {
        return this.getItemEcografia.estado;
      }
      return false;
    },
    isActiveRayosX() {
      if (this.getItemRayosX != null) {
        return this.getItemRayosX.estado;
      }
      return false;
    },
    isActiveTomografia() {
      if (this.getItemTomografia != null) {
        return this.getItemTomografia.estado;
      }
      return false;
    },
    isActiveMamografia() {
      if (this.getItemMamografia != null) {
        return this.getItemMamografia.estado;
      }
      return false;
    },
    isActiveArcoC() {
      if (this.getItemArcoC != null) {
        return this.getItemArcoC.estado;
      }
      return false;
    },
    isActiveFisioterapia() {
      if (this.getItemFisioterapia != null) {
        return this.getItemFisioterapia.estado;
      }
      return false;
    },
    isActiveTratamiento() {
      if (this.getItemTratamiento != null) {
        return this.getItemTratamiento.estado;
      }
      return false;
    },
    evolucionFiltered() {
      return this.evolucionMedicas.filter((item) => item.estado);
    },
    totalServicioComplementarios() {
      let total = 0;
      this.servicioComplementario.forEach((item) => {
        if (item.tipo_consumo_servicio === TIPO_CONSUMO_PRODUCTO_SERVICIO.VENTA) {
          total += parseFloat(item.precio);
        }
      });
      return total;
    },
    filterListaTemporalConsumoProducto() {
      return this.consumoProductos.filter((item) => item.estado === true);
    },
    totalImporte() {
      return this.filterListaTemporalConsumoProducto.reduce((total, producto) => {
        // Asegúrate de que producto.total sea un número válido y sin formato
        const totalProducto = parseFloat(producto.importe) || 0;
        return total + totalProducto;
      }, 0);
    },
    totalImporteSalaCama() {
      let total = 0;
      total = parseInt(this.diasTratamiento, 10) * parseFloat(this.getImporteXDiaSalaCama);
      return total;
    },
    fechaFirstPrecierre() {
      let fecha = null;
      if (this.preCierreData.first_fecha_precierre) {
        fecha = moment(this.preCierreData.first_fecha_precierre).format('DD/MM/YYYY');
      }
      return fecha;
    },
    horaFirstPrecierre() {
      let hora = null;
      if (this.preCierreData.first_fecha_precierre) {
        hora = moment(this.preCierreData.first_fecha_precierre).format('HH:mm:ss');
      }
      return hora;
    },
    colorBtnPieza() {
      let color = 'btn-warning';
      if (this.getIDItemChecked != null) {
        if (this.preCierreData.first_precierre_tratamiento
          && this.preCierreData.first_precierre_tratamiento
        ) {
          color = 'btn-precierre';
        } else {
          color = 'btn-success';
        }
      }
      return color;
    },
    ...mapFields('theModalInterConsulta', [
      'interConsultas',
    ]),
  },
  watch: {
    total() {
      if (this.tipoSeguroSeleccionado !== null) {
        this.verificarTotal();
      }
    },
    'dataPaciente.cobertura': {
      handler(newSeguro) {
        if (newSeguro) {
          const seguroEnLista = this.seguro.listaSeguros.find((seguro) => seguro.nombre_comercial === newSeguro);
          if (seguroEnLista) {
            this.seguro.model = seguroEnLista;
          } else {
            this.seguro.model = null;
          }
        }
      },
      deep: true, // Observa cambios profundos dentro de dataPaciente.cobertura
    },
    servicioComplementario: {
      handler(newValue) {
        if (Array.isArray(newValue)) {
          this.calcular();
        }
      },
      deep: true,
    },
    serviciosFiltered: {
      handler(newValue) {
        if (Array.isArray(newValue)) {
          this.calcular();
        }
      },
      deep: true,
    },
    'seguro.model': {
      handler(newValue) {
        if (newValue && newValue.id) {
          this.getTipoSeguro();
        }
      },
      deep: true,
      immediate: true,
    },
    'dataPaciente.id': {
      handler(newValue) {
        if (newValue) {
          this.calcular();
        }
      },
      immediate: true,
    },
    categoriaServicioComplId(new1) {
      if (new1) {
        this.filterListaTempServicioComplementario();
      }
    },
  },
};
</script>

<style scoped>
.btn-white{
  background: white;
  color: black;
}
.text-skyblue
{
  color: #61c6f2;
}
.bg-sky-light
{
  background:#a6d2eb;
}
.navbar-reubicado
{
  transform: translate(0px, -32px);
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
.tabla-scroll-vertical {
    overflow-y: scroll;
    height: 180px;
}
.btnBlue {
  color: white;
  background-color: #47404f;
}
.btnOrange {
  color: white;
  background-color: #F4B375;
}
.btnTurquesa {
  color: white;
  background-color: #319ba1;
}
.bg-abierto {
  background: #f8cb9e;
}
.custom-small-text {
  font-size: 8px; /* Ajusta según lo que necesites */
}
.btn-precierre {
  color: white;
  background-color: #484a6e;
}
.small-combo-diagnostic {
  font-size: 12px;
}

.small-card {
  height: 100%;
}

.small-text {
  font-size: 12px;
}

/* Estilo para el input */
.small-input {
  font-size: 12px;
  padding: 5px;
  height: 30px;
}
.small-combo-diagnostic .multiselect__input {
  font-size: 12px;
  height: 30px;
}
</style>
